(function () {
  'use strict';


  function $(selector, ctx) {
    if (typeof selector === 'function') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', selector);
      } else {
        selector();
      }
      return null;
    }
    var context = ctx || document;
    if (selector instanceof Element) return { el: selector, length: 1, selector: '' };
    if (selector instanceof NodeList) return { el: selector[0], list: selector, length: selector.length, selector: '' };
    if (typeof selector !== 'string') return { el: selector, length: 1, selector: '' };
    if (selector.charAt(0) === '<' && selector.charAt(selector.length - 1) === '>') {
      var tag = selector.slice(1, -1).split(/\s+/)[0];
      var el = document.createElement(tag);
      return wrap(el);
    }
    if (selector.charAt(0) === '#') {
      var el = document.getElementById(selector.slice(1));
      return wrap(el);
    }
    var list = context.querySelectorAll(selector);
    return wrap(list[0], list);
  }

  function wrap(el, list) {
    var w = {
      el: el,
      list: list || (el ? [el] : []),
      length: list ? list.length : (el ? 1 : 0),
      selector: ''
    };
    w.each = function(fn) { for (var i = 0; i < w.list.length; i++) fn.call(w.list[i], i, w.list[i]); return w; };
    w.find = function(s) {
      var results = [];
      w.list.forEach(function(e) {
        if (e) e.querySelectorAll(s).forEach(function(f) { results.push(f); });
      });
      return wrap(results[0], results);
    };
    w.closest = function(s) { return wrap(w.el ? w.el.closest(s) : null); };
    w.eq = function(i) { return wrap(w.list[i]); };
    w.first = function() { return wrap(w.list[0]); };
    w.val = function(v) {
      if (v === undefined) return w.el ? w.el.value : undefined;
      if (w.el) w.el.value = v;
      return w;
    };
    w.text = function(t) {
      if (t === undefined) return w.el ? w.el.textContent : '';
      if (w.el) w.el.textContent = t;
      return w;
    };
    w.html = function(h) {
      if (h === undefined) return w.el ? w.el.innerHTML : '';
      if (w.el) w.el.innerHTML = h;
      return w;
    };
    w.empty = function() { if (w.el) w.el.innerHTML = ''; return w; };
    w.append = function(htmlOrEl) {
      if (!w.el) return w;
      if (typeof htmlOrEl === 'string') w.el.insertAdjacentHTML('beforeend', htmlOrEl);
      else if (htmlOrEl instanceof Element) w.el.appendChild(htmlOrEl);
      else if (htmlOrEl.el) w.el.appendChild(htmlOrEl.el);
      return w;
    };
    w.prependTo = function(target) {
      var t = $(target);
      if (t.el && w.el) t.el.insertBefore(w.el, t.el.firstChild);
      return w;
    };
    w.addClass = function(c) { if (w.el) w.el.classList.add(c); return w; };
    w.removeClass = function(c) { if (w.el) w.el.classList.remove(c); return w; };
    w.toggleClass = function(c, force) { if (w.el) w.el.classList.toggle(c, force); return w; };
    w.hasClass = function(c) { return w.el ? w.el.classList.contains(c) : false; };
    w.css = function(prop, val) {
      if (typeof prop === 'string' && val !== undefined) { if (w.el) w.el.style[prop] = val; return w; }
      if (typeof prop === 'object') { if (w.el) Object.assign(w.el.style, prop); return w; }
      if (typeof prop === 'string') return w.el ? getComputedStyle(w.el)[prop] : '';
      return w;
    };
    w.prop = function(p, v) {
      if (v === undefined) return w.el ? w.el[p] : undefined;
      if (w.el) w.el[p] = v;
      return w;
    };
    w.attr = function(a, v) {
      if (v === undefined) return w.el ? w.el.getAttribute(a) : null;
      if (w.el) w.el.setAttribute(a, v);
      return w;
    };
    w.data = function(k, v) {
      if (v === undefined) return w.el ? w.el.dataset[k] : undefined;
      if (w.el) w.el.dataset[k] = v;
      return w;
    };
    w.on = function(evt, selectorOrFn, fn) {
      if (typeof selectorOrFn === 'function') {
        if (w.el) w.el.addEventListener(evt, selectorOrFn);
      } else {
        var delegateFn = function(e) {
          if (e.target && e.target.closest(selectorOrFn)) {
            fn.call(e.target.closest(selectorOrFn), e);
          }
        };
        if (w.el) w.el.addEventListener(evt, delegateFn);
      }
      return w;
    };
    w.off = function(evt, fn) {
      if (w.el && fn) w.el.removeEventListener(evt, fn);
      return w;
    };
    w.show = function() { if (w.el) w.el.style.display = ''; return w; };
    w.hide = function() { if (w.el) w.el.style.display = 'none'; return w; };
    w.toggle = function(show) {
      if (w.el) w.el.style.display = show ? '' : 'none';
      return w;
    };
    w.fadeIn = function(ms) {
      if (!w.el) return w;
      w.el.style.opacity = '0';
      w.el.style.display = '';
      (function fade() {
        var o = parseFloat(w.el.style.opacity);
        if (o < 1) {
          w.el.style.opacity = String(o + 0.1);
          requestAnimationFrame(fade);
        }
      })();
      return w;
    };
    w.fadeOut = function(ms, cb) {
      if (!w.el) return w;
      (function fade() {
        var o = parseFloat(w.el.style.opacity);
        if (o > 0) {
          w.el.style.opacity = String(o - 0.1);
          requestAnimationFrame(fade);
        } else {
          w.el.style.display = 'none';
          if (cb) cb.call(w.el);
        }
      })();
      return w;
    };
    w.stop = function() { return w; };
    w.is = function(s) {
      if (!w.el) return false;
      if (s === ':visible') return w.el.style.display !== 'none' && w.el.offsetParent !== null;
      return w.el.matches(s);
    };
    w.offset = function() {
      if (!w.el) return { top: 0, left: 0 };
      var rect = w.el.getBoundingClientRect();
      return { top: rect.top + window.scrollY, left: rect.left + window.scrollX };
    };
    w.scrollTop = function(v) {
      if (v !== undefined) { if (w.el) w.el.scrollTop = v; return w; }
      return w.el ? w.el.scrollTop : 0;
    };
    w.trigger = function(evt) {
      if (w.el) w.el.dispatchEvent(new Event(evt, { bubbles: true }));
      return w;
    };
    w[0] = w.el;
    return w;
  }

  $.ajax = function(opts) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(opts.method || 'GET', opts.url || '');
      if (opts.contentType) xhr.setRequestHeader('Content-Type', opts.contentType);
      if (opts.headers) {
        Object.keys(opts.headers).forEach(function(k) { xhr.setRequestHeader(k, opts.headers[k]); });
      }
      if (opts.dataType === 'json') {
        xhr.responseType = 'json';
      }
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response || xhr.responseText);
        } else {
          reject(xhr.statusText || 'Request failed');
        }
      };
      xhr.onerror = function() { reject('Network error'); };
      xhr.send(opts.data || null);
    });
  };

  $.Deferred = function() {
    var resolve, reject;
    var p = new Promise(function(rs, rj) { resolve = rs; reject = rj; });
    p.resolve = resolve;
    p.reject = reject;
    p.done = function(fn) { p.then(fn); return p; };
    p.fail = function(fn) { p.catch(fn); return p; };
    return p;
  };

  // ---- End helpers ----

  var productVariants = window.PRODUCT_VARIANTS || [];
  var optionPositions = window.OPTION_POSITIONS || {};
  var currentStep = 1;
  var totalSteps = window.HAS_ENGRAVING ? 4 : 3;
  var mediaItems = [];
  var currentIndex = 0;
  var isAnimating = false;
  var latestStullerProduct = null;
  var latestStoneGrouping = { centerStones: [], grouped: {} };
  var baseProductPrice = 0;
  var lastPriority = 'shape';
  var stullerRefreshTimeout = null;
  var LAB_GROWN_SEARCH_ENDPOINT = window.LAB_GROWN_SEARCH_ENDPOINT || '';
  var stoneModalState = {
    selectedGroupKey: '',
    selectedStone: null,
    baseResults: [],
    filterOptions: { cuts: [], colors: [], qualities: [] },
    filters: { cut: '', color: '', quality: '' },
    page: 1,
    perPage: 6,
    totalCount: 0,
    totalPages: 1,
  };
  var useMyStoneValues = {};

  function showLoader(show) {
    $('#viewer-loader').toggleClass('show', show);
  }

  function showInlineLoader(show) {
    var loader = document.getElementById('meta-inline-loader');
    if (!loader) return;
    loader.style.display = show ? 'flex' : 'none';
  }

  function showStepLoader(show) {
    $('#jc-step-loader').toggleClass('active', show);
  }

  function getPos(keyword) {
    for (var key in optionPositions) {
      if (key === keyword) return optionPositions[key];
    }
    for (var key in optionPositions) {
      var lowerKey = key.toLowerCase();
      if (keyword === 'size' && lowerKey.includes('finger')) continue;
      if (lowerKey.includes(keyword)) return optionPositions[key];
    }
    return null;
  }

  var shapePos = getPos('shape');
  var metalPos = getPos('metal');
  var sizePos = getPos('size');

  function findMatchingVariant() {
    var selectedShape = document.querySelector('.jc-shape-btn.active')?.dataset.shape;
    var selectedSize = document.getElementById('stone-size-select')?.value;
    var selectedMetal = document.getElementById('metal-select')?.value;

    var normSize = selectedSize ? selectedSize.toString().toLowerCase() : '';
    var normShape = selectedShape ? selectedShape.toString().toLowerCase() : '';
    var normMetal = selectedMetal ? selectedMetal.toString().toLowerCase() : '';

    function filterBy(list, type, value) {
      if (!value) return list;
      var pos = type === 'shape' ? shapePos : (type === 'metal' ? metalPos : sizePos);
      var filtered = list.filter(function(v) {
        var val = (v['option' + pos] || '').toLowerCase();
        return val === value || val.includes(value);
      });
      return filtered.length > 0 ? filtered : list;
    }

    var order = [];
    if (lastPriority === 'metal') {
      order = ['metal', 'shape', 'size'];
    } else if (lastPriority === 'size') {
      order = ['size', 'shape', 'metal'];
    } else {
      order = ['shape', 'metal', 'size'];
    }

    var matches = productVariants;
    var primaryType = order[0];
    var primaryVal = primaryType === 'shape' ? normShape : (primaryType === 'metal' ? normMetal : normSize);

    var tier1Matches = productVariants.filter(function(v) {
      var pos = primaryType === 'shape' ? shapePos : (primaryType === 'metal' ? metalPos : sizePos);
      var val = (v['option' + pos] || '').toLowerCase();
      return val === primaryVal || val.includes(primaryVal);
    });

    if (tier1Matches.length > 0) {
      matches = tier1Matches;
      matches = filterBy(matches, order[1], (order[1] === 'shape' ? normShape : (order[1] === 'metal' ? normMetal : normSize)));
      matches = filterBy(matches, order[2], (order[2] === 'shape' ? normShape : (order[2] === 'metal' ? normMetal : normSize)));
    } else {
      matches = productVariants.filter(function(v) {
        var val = (v['option' + shapePos] || '').toLowerCase();
        return val.includes(normShape);
      });
      if (matches.length === 0) matches = productVariants;
    }

    return matches[0];
  }

  function updateStepper(step) {
    currentStep = step;
    document.querySelectorAll('.step-item').forEach(function(item) {
      var itemStep = parseInt(item.dataset.step);
      var circle = item.querySelector('.step-circle');
      var label = item.querySelector('.step-label');
      circle.classList.remove('circle-active', 'circle-completed', 'circle-inactive');
      label.classList.remove('label-active', 'label-completed', 'label-inactive');
      if (itemStep < window.maxStepReached && itemStep !== currentStep) {
        circle.classList.add('circle-completed');
        label.classList.add('label-completed');
      } else if (itemStep === currentStep) {
        circle.classList.add('circle-active');
        label.classList.add('label-active');
      } else if (itemStep < window.maxStepReached) {
        circle.classList.add('circle-completed');
        label.classList.add('label-completed');
      } else {
        circle.classList.add('circle-inactive');
        label.classList.add('label-inactive');
      }
    });
    if (typeof window.maxStepReached === 'undefined') window.maxStepReached = 1;
    if (step > window.maxStepReached) window.maxStepReached = step;
    var progressWidth = ((window.maxStepReached - 1) / (totalSteps - 1)) * 100;
    $('#progress-bar').css('width', progressWidth + '%');
    showInlineLoader(true);
    setTimeout(function() { showInlineLoader(false); }, 600);
    showStepLoader(true);
    setTimeout(function() {
      document.querySelectorAll('.jc-step-content').forEach(function(el) { el.classList.remove('active'); });
      var currentEl = document.querySelector('.jc-step-content-' + currentStep);
      if (currentEl) currentEl.classList.add('active');
      showStepLoader(false);
      if (currentStep === totalSteps) updateReviewStep();
      var controls = document.querySelector('.jc-controls-col');
      if (controls) controls.scrollTop = 0;
      var jewelryStateSection = document.getElementById('jc-jewelry-state-section');
      if (jewelryStateSection) {
        jewelryStateSection.style.display = currentStep === 1 ? '' : 'none';
      }
    }, 350);
  }

  function updateReviewStep() {
    var shapeBtn = document.querySelector('.jc-shape-btn.active');
    var shape = shapeBtn ? shapeBtn.dataset.shape : '';
    var size = document.getElementById('stone-size-select')?.value || '';
    var metalSelect = document.getElementById('metal-select');
    var metal = metalSelect ? metalSelect.options[metalSelect.selectedIndex]?.text || '' : '';
    var price = $('#total-price').text();
    $('#review-mounting-text').text(metal);

    // Show selected center diamond if set, otherwise mounting stone specs
    if (window.selectedCenterStone) {
      var d = window.selectedCenterStone;
      var ct = parseFloat(d.carat || d.size || 0).toFixed(2);
      var pn = parseFloat(d.depth60_price || 0);
      var pr = isNaN(pn) ? '' : ' ($' + pn.toLocaleString() + ')';
      $('#review-stone-text').text((d.shape || '').toUpperCase() + ' ' + ct + 'ct' + pr);
    } else {
      $('#review-stone-text').text(size + ' mm ' + shape);
    }

    $('#review-price-text').text(price);
  }

  function showMedia(idx, animate) {
    if (isAnimating || !mediaItems.length) return;
    idx = Math.max(0, Math.min(idx, mediaItems.length - 1));
    currentIndex = idx;
    isAnimating = true;
    var item = mediaItems[idx];
    var $img = $('#active-img');
    var $vid = $('#active-video-wrap');
    showLoader(true);

    var doSwap = function() {
      if (item.type === 'image') {
        if (!$img.el) {
          var img = document.createElement('img');
          img.id = 'active-img';
          img.className = 'jc-media-item';
          img.loading = 'lazy';
          var inner = document.querySelector('.jc-viewer-inner');
          if (inner) inner.prepend(img);
          $img = $('#active-img');
        }
        $img.el.onload = function() {
          showLoader(false);
          $img.addClass('active');
          $vid.removeClass('active').empty();
          isAnimating = false;
        };
        $img.removeClass('active');
        if ($img.el) $img.el.src = item.url;
        $('#jc-zoom-img').attr('src', item.zoom || item.url);
        $vid.removeClass('active').empty();
      } else {
        showLoader(false);
        $vid.html('<video class="jc-media-item active" autoplay muted loop playsinline><source src="' + item.url + '" type="video/mp4"></video>').addClass('active');
        $img.removeClass('active');
        $('#jc-zoom-img').attr('src', '');
        isAnimating = false;
      }
      $('#media-counter').text((idx + 1) + ' / ' + mediaItems.length);
      document.querySelectorAll('.jc-thumb-node').forEach(function(n) { n.classList.remove('active'); });
      var thumbs = document.querySelectorAll('.jc-thumb-node');
      if (thumbs[idx]) thumbs[idx].classList.add('active');
      var activeThumb = document.querySelector('.jc-thumb-node.active');
      if (activeThumb) {
        var track = document.getElementById('thumb-track');
        if (track) {
          var thumbLeft = activeThumb.offsetLeft;
          var thumbWidth = activeThumb.offsetWidth;
          var trackWidth = track.offsetWidth;
          track.scrollTo({ left: thumbLeft - trackWidth / 2 + thumbWidth / 2, behavior: 'smooth' });
        }
      }
      updateThumbNavButtons();
    };

    if (animate === false) {
      doSwap();
    } else {
      setTimeout(doSwap, 160);
    }
  }

  function buildThumbnails(data) {
    mediaItems = [];
    var track = document.getElementById('thumb-track');
    if (!track) return;
    track.innerHTML = '';
    (data.images || []).forEach(function(img) {
      var zoomUrl = img.ZoomUrl || img.FullUrl || '';
      if (zoomUrl.indexOf('stullercloud.com') !== -1 && zoomUrl.indexOf('$standard$') !== -1) {
        zoomUrl = zoomUrl.replace('$standard$', '$zoom$');
      }
      mediaItems.push({ type: 'image', thumb: img.ThumbnailUrl || img.FullUrl, url: img.FullUrl, zoom: zoomUrl });
    });
    (data.videos || []).forEach(function(vid) {
      var fallback = (data.images && data.images[0] ? (data.images[0].ThumbnailUrl || data.images[0].FullUrl) : '');
      var videoUrl = vid.DownloadUrl || vid.Url;
      mediaItems.push({ type: 'video', thumb: fallback, url: videoUrl });
    });
    mediaItems.forEach(function(item, i) {
      var div = document.createElement('div');
      div.className = 'jc-thumb-node';
      div.dataset.index = i;
      if (item.type === 'video') {
        div.innerHTML = '<img src="' + item.thumb + '" alt="Video ' + (i + 1) + '" loading="lazy"><div class="jc-video-overlay"><span class="jc-360-badge">360°</span></div>';
      } else {
        div.innerHTML = '<img src="' + item.thumb + '" alt="Image ' + (i + 1) + '" loading="lazy">';
      }
      div.addEventListener('click', function() { showMedia(i); });
      track.appendChild(div);
    });
    showMedia(0, false);
    updateThumbNavButtons();
  }

  function updateThumbNavButtons() {
    var track = document.getElementById('thumb-track');
    if (!track) return;
    var maxScroll = track.scrollWidth - track.offsetWidth;
    $('#thumb-left').prop('disabled', track.scrollLeft <= 2);
    $('#thumb-right').prop('disabled', track.scrollLeft >= maxScroll - 2);
  }

  function updateSpecs(data) {
    if (!data.specs && !data.setting_specs) return;
    var specs = data.specs || data.setting_specs || [];
    var $tbody = $('#spec-tbody');
    if (document.getElementById('spec-stone-shape')) {
      var shapeBtn = document.querySelector('.jc-shape-btn.active');
      if (shapeBtn) document.getElementById('spec-stone-shape').textContent = shapeBtn.dataset.shape;
    }
    if (document.getElementById('spec-stone-size')) {
      var sizeVal = document.getElementById('stone-size-select')?.value;
      if (sizeVal) document.getElementById('spec-stone-size').textContent = sizeVal + ' mm';
    }
    specs.forEach(function(spec) {
      if (spec.SizeMM > 0 && spec.Description) {
        var key = spec.Description;
        var found = false;
        var tbodyEl = document.getElementById('spec-tbody');
        if (tbodyEl) {
          tbodyEl.querySelectorAll('tr').forEach(function(row) {
            var keyEl = row.querySelector('.jc-spec-key');
            if (keyEl && keyEl.textContent.includes(key)) found = true;
          });
        }
        if (!found && tbodyEl) {
          tbodyEl.insertAdjacentHTML('beforeend', '<tr><td class="jc-spec-key">' + key + '</td><td class="jc-spec-val">' + spec.SizeMM + 'mm ' + (spec.Shape || '') + '</td></tr>');
        }
      }
    });
  }

  function parseStoneSizeValue(sizeValue) {
    var raw = (sizeValue || '').toString().trim();
    if (!raw) return { SizeMM: 0, Dimension1: 0, Dimension2: 0 };
    var parts = raw.split(/x/i).map(function(part) { return Number(String(part).trim()); });
    var n1 = Number.isFinite(parts[0]) ? parts[0] : 0;
    var n2 = Number.isFinite(parts[1]) ? parts[1] : 0;
    if (n1 > 0 && n2 > 0) return { SizeMM: Math.max(n1, n2), Dimension1: n1, Dimension2: n2 };
    return { SizeMM: n1 > 0 ? n1 : 0, Dimension1: n1 > 0 ? n1 : 0, Dimension2: 0 };
  }

  function normalizeStoneIdentity(shape, sizeMM, dimension1, dimension2) {
    var shapeKey = (shape || '').toString().trim().toLowerCase();
    var d1 = Number(dimension1 || 0);
    var d2 = Number(dimension2 || 0);
    if (d1 > 0 && d2 > 0) {
      var large = Math.max(d1, d2).toFixed(2);
      var small = Math.min(d1, d2).toFixed(2);
      return shapeKey + '|' + large + 'x' + small;
    }
    var mm = Number(sizeMM || d1 || 0);
    return shapeKey + '|' + (mm > 0 ? mm.toFixed(2) : '0.00');
  }

  function getRawSettingOptions(data) {
    var config = data && (data.ConfigurationModel || data.configurationModel) ? (data.ConfigurationModel || data.configurationModel) : {};
    var options = config.SettingOptions || config.settingOptions || [];
    return Array.isArray(options) ? options : [];
  }

  function buildSettingOptionGroupBuckets(settingOptions) {
    var buckets = {};
    (settingOptions || []).forEach(function(stone) {
      var groupName = (stone.GroupName || stone.groupName || '').toString().trim();
      if (!groupName) return;
      var key = normalizeStoneIdentity(stone.Shape, stone.SizeMM, stone.Dimension1, stone.Dimension2);
      if (!buckets[key]) buckets[key] = [];
      buckets[key].push(groupName);
    });
    return buckets;
  }

  function buildCanBeSetWithOptions(data, settingOptions) {
    var raw = (data && (data.CanBeSetWith || data.can_be_set_with)) || [];
    if (!Array.isArray(raw) || !raw.length) return [];
    var groupBuckets = buildSettingOptionGroupBuckets(settingOptions || []);
    var normalized = raw.map(function(item) {
      var parsedSize = parseStoneSizeValue(item.Size);
      var quantity = Math.max(1, Number(item.Quantity || 1));
      var groupName = (item.GroupName || item.groupName || '').toString().trim();
      return {
        Quantity: quantity,
        GroupName: groupName,
        Shape: (item.Shape || '').toString().trim(),
        SettingType: (item.SettingType || '').toString().trim(),
        SizeMM: parsedSize.SizeMM,
        Dimension1: parsedSize.Dimension1,
        Dimension2: parsedSize.Dimension2,
      };
    });
    var expanded = [];
    normalized.forEach(function(stone) {
      var key = normalizeStoneIdentity(stone.Shape, stone.SizeMM, stone.Dimension1, stone.Dimension2);
      var groupQueue = groupBuckets[key] || [];
      for (var i = 0; i < stone.Quantity; i++) {
        var inheritedGroupName = groupQueue.length ? groupQueue.shift() : '';
        expanded.push({
          GroupName: stone.GroupName || inheritedGroupName,
          Shape: stone.Shape,
          SettingType: stone.SettingType,
          SizeMM: stone.SizeMM,
          Dimension1: stone.Dimension1,
          Dimension2: stone.Dimension2,
        });
      }
    });
    return expanded;
  }

  function getSettingOptions(data) {
    var settingOptions = getRawSettingOptions(data);
    var canBeSetWithOptions = buildCanBeSetWithOptions(data, settingOptions);
    if (canBeSetWithOptions.length) return canBeSetWithOptions;
    if (settingOptions.length) return settingOptions;
    // Fallback: generate stone options from SERIES_SKU_MAP
    var map = window.SERIES_SKU_MAP || [];
    if (!map.length) return [];
    var state = getSelectedJewelryState();
    var metalEl = document.getElementById('metal-select');
    var currentMetal = metalEl ? metalEl.value : '';
    var stateFiltered = state ? map.filter(function(e) { return (e.jewelry_state || '') === state; }) : map;
    var metalFiltered = currentMetal ? stateFiltered.filter(function(e) { return (e.metal || '') === currentMetal; }) : stateFiltered;
    if (!metalFiltered.length) metalFiltered = stateFiltered;
    var seen = {}, generated = [];
    metalFiltered.forEach(function(entry) {
      var shape = (entry.shape || '').trim();
      var size = (entry.size || '').trim();
      if (!shape || !size) return;
      var key = shape.toLowerCase() + '_' + size;
      if (!seen[key]) { seen[key] = true; generated.push({ GroupName: 'Center', Shape: shape, SizeMM: parseFloat(size) || 0, SettingType: 'Prong' }); }
    });
    return generated;
  }

  function escapeHtml(value) {
    return (value || '').toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function normalizeStoneGroupKey(groupName) {
    return 'group:' + (groupName || '').toString().trim().toLowerCase();
  }

  function getStoneGroupDisplayOrder(groupName, groupStones) {
    var name = (groupName || '').toString().trim().toLowerCase();
    if (name === 'halo') return 1;
    var accentMatch = name.match(/^accent\s*(\d+)$/i);
    if (accentMatch) {
      var accentNum = Number(accentMatch[1] || 0);
      return 10 + (Number.isFinite(accentNum) ? accentNum : 0);
    }
    var representative = getGroupRepresentativeStone(groupStones);
    var measure = getStoneMeasure(representative || {});
    return 50 - measure;
  }

  function getStoneMapImage(data) {
    return (data && (data.StoneMapImage || data.stoneMapImage)) || '';
  }

  function formatStoneSize(stone) {
    var dimension1 = Number(stone.Dimension1 || stone.SizeMM || 0);
    var dimension2 = Number(stone.Dimension2 || 0);
    if (dimension1 > 0 && dimension2 > 0) return dimension1.toFixed(2) + ' mm x ' + dimension2.toFixed(2) + ' mm';
    if (stone.SizeMM) return Number(stone.SizeMM).toFixed(2) + ' mm';
    return 'N/A';
  }

  function getStoneMeasure(stone) {
    var sizeMM = Number(stone.SizeMM || 0);
    if (sizeMM > 0) return sizeMM;
    return Number(stone.Dimension1 || 0);
  }

  function getStoneIconId(shapeName) {
    var shape = (shapeName || '').toString().toLowerCase();
    if (shape.includes('round')) return 'dia-faceted-round';
    if (shape.includes('oval')) return 'dia-faceted-oval';
    if (shape.includes('princess')) return 'dia-faceted-princess';
    if (shape.includes('emerald')) return 'dia-faceted-emerald';
    if (shape.includes('pear')) return 'dia-faceted-pear';
    if (shape.includes('marquise')) return 'dia-faceted-marquise';
    if (shape.includes('cushion')) return 'dia-faceted-cushion';
    if (shape.includes('asscher')) return 'dia-faceted-asscher';
    if (shape.includes('heart')) return 'dia-faceted-heart';
    if (shape.includes('trillion')) return 'dia-faceted-trillion';
    if (shape.includes('radiant')) return 'dia-faceted-radiant';
    if (shape.includes('baguette')) return 'dia-faceted-straight-baguette';
    return 'dia-faceted-round';
  }

  function getGroupRepresentativeStone(groupStones) {
    if (!Array.isArray(groupStones) || !groupStones.length) return null;
    return groupStones.slice().sort(function(a, b) { return getStoneMeasure(b) - getStoneMeasure(a); })[0];
  }

  function groupSettingOptions(stones) {
    var stonesWithGroupName = stones.filter(function(stone) { return (stone.GroupName || '').toString().trim() !== ''; });
    var hasNamedGroups = stonesWithGroupName.length > 0;
    if (!hasNamedGroups) {
      var sorted = stones.slice().sort(function(a, b) { return getStoneMeasure(b) - getStoneMeasure(a); });
      var center = sorted[0] ? [sorted[0]] : [];
      var accent = sorted.slice(1);
      return { centerStones: center, grouped: accent.length ? { Accent: accent } : {} };
    }
    var centerStones = stones.filter(function(stone) { return (stone.GroupName || '').toString().toLowerCase() === 'center'; });
    var nonCenter = stones.filter(function(stone) { return (stone.GroupName || '').toString().toLowerCase() !== 'center'; });
    var grouped = nonCenter.reduce(function(acc, stone) {
      var groupName = (stone.GroupName || '').toString().trim() || 'Accent';
      if (!acc[groupName]) acc[groupName] = [];
      acc[groupName].push(stone);
      return acc;
    }, {});
    if (!centerStones.length) {
      var allNonCenter = Object.values(grouped).flat();
      if (allNonCenter.length) {
        var largest = getGroupRepresentativeStone(allNonCenter);
        Object.keys(grouped).forEach(function(groupName) {
          grouped[groupName] = grouped[groupName].filter(function(stone) { return stone !== largest; });
          if (!grouped[groupName].length) delete grouped[groupName];
        });
        return { centerStones: largest ? [largest] : [], grouped: grouped };
      }
    }
    return { centerStones: centerStones, grouped: grouped };
  }

  function renderStoneGroupRow(groupName, groupStones, isCenter) {
    var representative = getGroupRepresentativeStone(groupStones);
    if (!representative) return '';
    var iconId = getStoneIconId(representative.Shape);
    var count = groupStones.length;
    var countText = count + ' stone' + (count === 1 ? '' : 's');
    var setLabel = isCenter ? 'Set' : 'Set ' + count + ' Stones';
    var groupKey = isCenter ? 'center' : normalizeStoneGroupKey(groupName);
    var sizeText = formatStoneSize(representative);
    var locationLabel = getLocationLabel(groupName, isCenter, count);
    return '<div class="jc-stone-location-card"><div><div class="jc-stone-location-name">' + groupName + '</div>' + (count > 1 || !isCenter ? '<div class="jc-stone-location-count"><span class="jc-stone-plus">+</span> ' + countText + '</div>' : '') + '</div><div class="jc-stone-shape-preview" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><use width="100%" height="100%" href="#' + iconId + '" xlink:href="#' + iconId + '"></use></svg></div><div><div class="jc-stone-location-size">' + formatStoneSize(representative) + '</div><div class="jc-stone-location-meta">' + (representative.Shape || 'Diamond') + ' &middot; ' + (representative.SettingType || 'Setting') + '</div></div><div class="jc-stone-location-actions"><button type="button" class="jc-stone-set-btn" data-stone-group-key="' + encodeURIComponent(groupKey) + '" data-group-name="' + escapeHtml(groupName) + '" data-shape="' + escapeHtml(representative.Shape || '') + '" data-size="' + getStoneMeasure(representative) + '" data-size-label="' + escapeHtml(sizeText) + '" data-location-label="' + escapeHtml(locationLabel) + '">' + setLabel + '</button>' + (isCenter ? '<a href="#" class="jc-stone-use-link" data-group-key="' + encodeURIComponent(groupKey) + '" data-group-name="' + escapeHtml(groupName) + '" data-shape="' + escapeHtml(representative.Shape || '') + '" data-size="' + getStoneMeasure(representative) + '" data-size-label="' + escapeHtml(sizeText) + '" data-location-label="' + escapeHtml(locationLabel) + '">Use My Stone</a>' : '') + '</div></div>';
  }

  function getLocationLabel(groupName, isCenter, count) {
    if (isCenter) return 'Stone 1 (Center)';
    return groupName + (count > 1 ? ' (' + count + ')' : '');
  }

  function renderStoneModalRow(groupName, groupStones, isCenter, selectedGroupKey) {
    var representative = getGroupRepresentativeStone(groupStones);
    if (!representative) return '';
    var count = groupStones.length;
    var label = isCenter ? groupName + ' (' + count + ' Center)' : groupName + ' (' + count + ' stones)';
    var iconId = getStoneIconId(representative.Shape);
    var groupKey = isCenter ? 'center' : normalizeStoneGroupKey(groupName);
    var activeClass = selectedGroupKey && selectedGroupKey === groupKey ? 'is-active' : '';
    var sizeText = formatStoneSize(representative);
    var locationLabel = getLocationLabel(groupName, isCenter, count);
    return '<div class="jc-stone-modal-row ' + activeClass + '"><div class="jc-stone-modal-row-name">' + escapeHtml(label) + '</div><div class="jc-stone-modal-row-size"><span class="jc-stone-modal-shape" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><use width="100%" height="100%" href="#' + iconId + '" xlink:href="#' + iconId + '"></use></svg></span><span>' + escapeHtml(sizeText) + '</span></div><button type="button" class="jc-stone-modal-select-btn" data-group-key="' + encodeURIComponent(groupKey) + '" data-group-name="' + escapeHtml(groupName) + '" data-shape="' + escapeHtml(representative.Shape || '') + '" data-size="' + getStoneMeasure(representative) + '" data-size-label="' + escapeHtml(sizeText) + '" data-location-label="' + escapeHtml(locationLabel) + '">Select</button><a href="#" class="jc-stone-modal-use-link" data-group-key="' + encodeURIComponent(groupKey) + '" data-group-name="' + escapeHtml(groupName) + '" data-shape="' + escapeHtml(representative.Shape || '') + '" data-size="' + getStoneMeasure(representative) + '" data-size-label="' + escapeHtml(sizeText) + '" data-location-label="' + escapeHtml(locationLabel) + '">Use My Stone</a></div>';
  }

  function renderStoneLocationModalRows(groupedResult, selectedGroupKey) {
    if (!groupedResult) return '';
    var parts = [];
    var groupedByName = groupedResult.grouped || {};
    var groupNames = Object.keys(groupedByName).sort(function(a, b) {
      return getStoneGroupDisplayOrder(a, groupedByName[a]) - getStoneGroupDisplayOrder(b, groupedByName[b]);
    });
    groupNames.forEach(function(groupName) {
      parts.push(renderStoneModalRow(groupName, groupedByName[groupName], false, selectedGroupKey));
    });
    return parts.join('');
  }

  function formatMoney(value) {
    var n = Number(value || 0);
    if (!Number.isFinite(n) || n <= 0) return '-';
    return '$' + n.toFixed(2);
  }

  function formatCarat(value) {
    var n = Number(value || 0);
    if (!Number.isFinite(n) || n <= 0) return '-';
    return n.toFixed(2);
  }

  function updateStoneSetStatus(groupKey, diamond) {
    var cards = document.querySelectorAll('.jc-stone-location-card');
    cards.forEach(function(card) {
      var btn = card.querySelector('.jc-stone-set-btn');
      if (!btn) return;
      var cardGroupKey = btn.getAttribute('data-stone-group-key') || '';
      if (decodeURIComponent(cardGroupKey) === groupKey) {
        card.classList.add('jc-stone-set');
        var existingBadge = card.querySelector('.jc-stone-selected-badge');
        if (!existingBadge) {
          var badge = document.createElement('div');
          badge.className = 'jc-stone-selected-badge';
          badge.textContent = 'Diamond Selected';
          card.appendChild(badge);
        }
      }
    });
  }

  function getSavedSideStone(groupKey) {
    try {
      var data = sessionStorage.getItem('selected_side_stone_' + groupKey);
      return data ? JSON.parse(data) : null;
    } catch(e) { return null; }
  }

  function getSelectedStoneFromEl(el) {
    return {
      groupKey: decodeURIComponent(el.getAttribute('data-group-key') || ''),
      groupName: el.getAttribute('data-group-name') || '',
      shape: el.getAttribute('data-shape') || '',
      size: Number(el.getAttribute('data-size') || 0),
      sizeLabel: el.getAttribute('data-size-label') || 'N/A',
      locationLabel: el.getAttribute('data-location-label') || '',
    };
  }

  function applyStoneFilters(rows, filters) {
    return (rows || []).filter(function(row) {
      var cut = (filters.cut || '').toLowerCase();
      var color = (filters.color || '').toLowerCase();
      var quality = (filters.quality || '').toLowerCase();
      if (cut && (row.cut || '').toString().toLowerCase() !== cut) return false;
      if (color && (row.color || '').toString().toLowerCase() !== color) return false;
      if (quality && (row.quality || '').toString().toLowerCase() !== quality) return false;
      return true;
    });
  }

  function getFilterOptionsFromResults(rows) {
    var cuts = new Set();
    var colors = new Set();
    var qualities = new Set();
    (rows || []).forEach(function(row) {
      if (row.cut) cuts.add(row.cut);
      if (row.color) colors.add(row.color);
      if (row.quality) qualities.add(row.quality);
    });
    return { cuts: Array.from(cuts).sort(function(a, b) { return a.localeCompare(b); }), colors: Array.from(colors).sort(function(a, b) { return a.localeCompare(b); }), qualities: Array.from(qualities).sort(function(a, b) { return a.localeCompare(b); }) };
  }

  function renderFilterOptions(options, current) {
    var allOpt = '<option value="">All</option>';
    return allOpt + options.map(function(value) { return '<option value="' + escapeHtml(value) + '" ' + (current === value ? 'selected' : '') + '>' + escapeHtml(value) + '</option>'; }).join('');
  }

  function renderPaginationButtons(page, totalPages) {
    if (totalPages <= 1) return '';
    var buttons = [];
    var addButton = function(label, targetPage, extraClass, disabled) {
      buttons.push('<button type="button" class="jc-stone-pagination-btn ' + (extraClass || '') + '" data-page="' + targetPage + '" ' + (disabled ? 'disabled' : '') + '>' + label + '</button>');
    };
    addButton('Prev', Math.max(1, page - 1), '', page === 1);
    var visiblePages = 5;
    var start = Math.max(1, page - 2);
    var end = Math.min(totalPages, start + visiblePages - 1);
    start = Math.max(1, end - visiblePages + 1);
    if (start > 1) {
      addButton('1', 1, page === 1 ? 'active' : '');
      if (start > 2) buttons.push('<span class="jc-stone-pagination-ellipsis">...</span>');
    }
    for (var i = start; i <= end; i++) {
      addButton(String(i), i, i === page ? 'active' : '');
    }
    if (end < totalPages) {
      if (end < totalPages - 1) buttons.push('<span class="jc-stone-pagination-ellipsis">...</span>');
      addButton(String(totalPages), totalPages, page === totalPages ? 'active' : '');
    }
    addButton('Next', Math.min(totalPages, page + 1), '', page === totalPages);
    return buttons.join('');
  }

  function renderSearchResultsTable(rows) {
    return '<table class="jc-stone-results-table"><thead><tr><th></th><th>Shape</th><th>Cut</th><th>Color</th><th>Quality</th><th>Uniqueness</th><th>MM Size</th><th>Size Ct</th><th>Price/ct</th><th>Est. Price</th><th></th></tr></thead><tbody>' + rows.map(function(row) {
      var thumb = row.image_url ? '<img src="' + escapeHtml(row.image_url) + '" alt="" class="jc-stone-thumb" style="width:36px;height:36px;object-fit:cover;border-radius:4px;display:block">' : '<div style="width:36px;height:36px;background:#eee;border-radius:4px"></div>';
      return '<tr><td>' + thumb + '</td><td>' + escapeHtml(row.shape || '-') + '</td><td>' + escapeHtml(row.cut || '-') + '</td><td>' + escapeHtml(row.color || '-') + '</td><td>' + escapeHtml(row.quality || '-') + '</td><td>' + escapeHtml(row.uniqueness || 'Lab-Grown Diamond') + '</td><td>' + escapeHtml(row.mm_size || '-') + '</td><td>' + formatCarat(row.size_ct) + '</td><td>' + formatMoney(row.price_per_carat) + '</td><td>' + formatMoney(row.est_price) + '</td><td><button type="button" class="jc-stone-results-set-btn" data-id="' + row.id + '">Set</button></td></tr>';
    }).join('') || '<tr><td colspan="11">No stones matched your filters.</td></tr>' + '</tbody></table>';
  }

  function renderSearchResultsFragment() {
    var stone = stoneModalState.selectedStone;
    if (!stone) return;
    var rows = stoneModalState.baseResults || [];
    var totalPages = Math.max(1, stoneModalState.totalPages || 1);
    var currentPage = Math.max(1, stoneModalState.page || 1);
    var metaEl = document.getElementById('jc-stone-search-meta');
    var wrapEl = document.getElementById('jc-stone-results-wrap');
    var paginationEl = document.getElementById('jc-stone-pagination');
    if (metaEl) metaEl.innerHTML = stoneModalState.totalCount + ' Results<br>Showing Lab-Grown';
    if (wrapEl) wrapEl.innerHTML = renderSearchResultsTable(rows);
    if (paginationEl) paginationEl.innerHTML = renderPaginationButtons(currentPage, totalPages);
  }

  function renderSearchResultsShell() {
    var stone = stoneModalState.selectedStone;
    if (!stone) return;
    var filterOptions = stoneModalState.filterOptions;
    var iconId = getStoneIconId(stone.shape);
    var rows = stoneModalState.baseResults || [];
    var totalPages = Math.max(1, stoneModalState.totalPages || 1);
    var currentPage = Math.max(1, stoneModalState.page || 1);
    $('#jc-stone-location-modal-title').text('Stone Search Results');
    var content = '<div class="jc-stone-search-shell"><div class="jc-stone-modal-view-head"><div class="jc-stone-modal-view-subtitle"><strong>' + escapeHtml(stone.locationLabel) + '</strong><span class="jc-stone-modal-shape" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><use width="100%" height="100%" href="#' + iconId + '" xlink:href="#' + iconId + '"></use></svg></span>' + escapeHtml(stone.sizeLabel) + '</div><button type="button" class="jc-stone-modal-back-btn">&lsaquo; Back</button></div><div class="jc-stone-search-panel"><div class="jc-stone-search-tab">Without Grading Report (' + rows.length + ')</div><div class="jc-stone-search-filters"><div class="jc-stone-search-filter"><label for="jc-stone-filter-cut">Cut</label><select id="jc-stone-filter-cut" class="jc-search-filter-select" data-filter="cut">' + renderFilterOptions(filterOptions.cuts || [], stoneModalState.filters.cut || '') + '</select></div><div class="jc-stone-search-filter"><label for="jc-stone-filter-color">Color</label><select id="jc-stone-filter-color" class="jc-search-filter-select" data-filter="color">' + renderFilterOptions(filterOptions.colors || [], stoneModalState.filters.color || '') + '</select></div><div class="jc-stone-search-filter"><label for="jc-stone-filter-quality">Quality</label><select id="jc-stone-filter-quality" class="jc-search-filter-select" data-filter="quality">' + renderFilterOptions(filterOptions.qualities || [], stoneModalState.filters.quality || '') + '</select></div><button type="button" class="jc-stone-search-reset">Reset</button></div></div><div id="jc-stone-search-meta" class="jc-stone-search-meta">' + (stoneModalState.totalCount || 0) + ' Results<br>Showing Lab-Grown</div><div id="jc-stone-results-wrap" class="jc-stone-results-wrap">' + renderSearchResultsTable(rows) + '</div><div id="jc-stone-pagination" class="jc-stone-pagination">' + renderPaginationButtons(currentPage, totalPages) + '</div><div class="jc-stone-empty" style="clear:both;">If you don\'t find a stone you like, try adjusting the size tolerance in your search or contact us.</div></div>';
    $('#jc-stone-modal-content').html(content);
  }

  function loadStoneSearchPage(page) {
    var stone = stoneModalState.selectedStone;
    if (!stone) return;
    stoneModalState.page = page || 1;
    var $content = $('#jc-stone-modal-content');
    if (!$content.find('#jc-stone-results-wrap').length) {
      $content.html('<div class="jc-stone-loading">Loading available lab-grown stones...</div>');
    } else {
      $('#jc-stone-results-wrap').html('<div class="jc-stone-loading">Loading available lab-grown stones...</div>');
    }
    fetchLabGrownDiamonds(stone, stoneModalState.page, stoneModalState.perPage, stoneModalState.filters)
      .then(function(resp) {
        var rows = resp && Array.isArray(resp.results) ? resp.results : [];
        stoneModalState.baseResults = rows;
        stoneModalState.filterOptions = resp && resp.filters ? resp.filters : getFilterOptionsFromResults(rows);
        stoneModalState.totalCount = Number(resp && resp.total_count ? resp.total_count : rows.length);
        stoneModalState.totalPages = Number(resp && resp.total_pages ? resp.total_pages : 1);
        stoneModalState.page = Number(resp && resp.page ? resp.page : stoneModalState.page) || 1;
        stoneModalState.perPage = Number(resp && resp.per_page ? resp.per_page : stoneModalState.perPage) || 6;
        if ($content.find('#jc-stone-results-wrap').length) {
          renderSearchResultsFragment();
        } else {
          renderSearchResultsShell();
        }
      })
      .catch(function() {
        if ($content.find('#jc-stone-results-wrap').length) {
          $('#jc-stone-results-wrap').html('<div class="jc-stone-empty">Unable to fetch lab-grown stones right now.</div>');
        } else {
          $content.html('<div class="jc-stone-empty">Unable to fetch lab-grown stones right now.</div>');
        }
      });
  }

  function renderStoneLocationListView(selectedGroupKey) {
    var rowsHtml = renderStoneLocationModalRows(latestStoneGrouping, selectedGroupKey);
    var productTitle = latestStullerProduct && (latestStullerProduct.GroupDescription || latestStullerProduct.Description) ? (latestStullerProduct.GroupDescription || latestStullerProduct.Description) : 'Engagement Ring';
    $('#jc-stone-location-modal-title').text('Stone Locations');
    $('#jc-stone-modal-content').html('<div class="jc-stone-modal-view-head"><div class="jc-stone-modal-view-subtitle">' + escapeHtml(productTitle) + '</div></div><div class="jc-stone-modal-rows">' + (rowsHtml || '<div class="jc-stone-empty" style="margin-top:14px;">No stone locations available.</div>') + '</div><div class="jc-stone-location-modal-actions"><button type="button" id="jc-stone-location-modal-done" class="jc-stone-location-modal-done">Done</button></div>');
  }

  function renderSearchResultsView() {
    renderSearchResultsShell();
  }

  function renderUseMyStoneView(stone) {
    var iconId = getStoneIconId(stone.shape);
    var savedValue = useMyStoneValues[stone.groupKey] || '0';
    $('#jc-stone-location-modal-title').text('Stone Locations');
    $('#jc-stone-modal-content').html('<div class="jc-use-stone-shell"><div class="jc-stone-modal-view-head"><div class="jc-use-stone-title">Use my stone for Location : ' + escapeHtml(stone.locationLabel) + '<span class="jc-stone-modal-shape" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><use width="100%" height="100%" href="#' + iconId + '" xlink:href="#' + iconId + '"></use></svg></span>' + escapeHtml(stone.sizeLabel) + '</div></div><div class="jc-use-stone-panel"><label for="jc-use-stone-value">Please enter the estimated value of the stone:</label><div class="jc-use-stone-input-wrap"><span>$</span><input id="jc-use-stone-value" type="number" min="0" step="0.01" value="' + escapeHtml(savedValue) + '"></div><div class="jc-use-stone-actions"><button type="button" class="jc-use-stone-save">SAVE</button><button type="button" class="jc-use-stone-cancel">Cancel</button></div></div></div>');
  }

  function fetchLabGrownDiamonds(stone, page, perPage, filters) {
    var url = window.LAB_GROWN_API_URL || '/shopify_section/get_labgrown_diamonds.php';
    var sizeLabel = (stone.sizeLabel || '').replace(' mm x ', ' x ').replace(' mm', '');
    if (sizeLabel === 'N/A' || sizeLabel === '') sizeLabel = String(stone.size || '');

    return new Promise(function(resolve, reject) {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shape: stone.shape || '',
          size_label: sizeLabel,
          cut: (filters && filters.cut) || '',
          color: (filters && filters.color) || '',
          quality: (filters && filters.quality) || '',
          page: page || 1,
          per_page: perPage || 6
        })
      })
        .then(function(res) { return res.json(); })
        .then(function(response) {
          if (!response.success) {
            resolve({ results: [], filters: { cuts: [], colors: [], qualities: [] }, total_count: 0, total_pages: 1, page: 1, per_page: perPage || 6 });
            return;
          }
          var results = (response.results || []).map(function(d) {
            var carat = parseFloat(d.carat_weight || d.size_ct || 0);
            var price = parseFloat(d.est_price || 0);
            return {
              id: d.id || 0,
              serial_number: d.serial_number || '',
              shape: d.shape || stone.shape || '',
              cut: d.cut || '',
              color: d.color || '',
              quality: d.quality || '',
              uniqueness: d.uniqueness || 'Lab-Grown Diamond',
              mm_size: d.mm_size || '',
              size_ct: carat,
              price_per_carat: parseFloat(d.price_per_carat || 0),
              est_price: price,
              image_url: d.image_url || ''
            };
          });
          resolve({
            results: results,
            filters: response.filters || { cuts: [], colors: [], qualities: [] },
            total_count: response.total_count || results.length,
            total_pages: response.total_pages || 1,
            page: response.page || 1,
            per_page: response.per_page || perPage || 6
          });
        })
        .catch(function(err) {
          reject(err);
        });
    });
  }

  function openStoneLocationModal(selectedGroupKey) {
    if (!latestStullerProduct) return;
    stoneModalState.selectedGroupKey = selectedGroupKey || '';
    stoneModalState.selectedStone = null;
    stoneModalState.baseResults = [];
    stoneModalState.filterOptions = { cuts: [], colors: [], qualities: [] };
    stoneModalState.filters = { cut: '', color: '', quality: '' };
    var modal = document.getElementById('jc-stone-location-modal');
    if (!modal) return;
    var mapEl = document.getElementById('jc-stone-modal-map');
    var mapEmptyEl = document.getElementById('jc-stone-modal-map-empty');
    var mapUrl = getStoneMapImage(latestStullerProduct);
    if (mapUrl) {
      if (mapEl) { mapEl.src = mapUrl; mapEl.style.display = ''; }
      if (mapEmptyEl) mapEmptyEl.style.display = 'none';
    } else {
      if (mapEl) { mapEl.removeAttribute('src'); mapEl.style.display = 'none'; }
      if (mapEmptyEl) mapEmptyEl.style.display = '';
    }
    renderStoneLocationListView(selectedGroupKey || '');
    modal.style.display = 'flex';
    modal.style.opacity = '0';
    (function fadeIn() {
      var o = parseFloat(modal.style.opacity);
      if (o < 1) {
        modal.style.opacity = String(o + 0.2);
        requestAnimationFrame(fadeIn);
      }
    })();
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeStoneLocationModal() {
    var modal = document.getElementById('jc-stone-location-modal');
    if (!modal) return;
    (function fadeOut() {
      var o = parseFloat(modal.style.opacity);
      if (o > 0) {
        modal.style.opacity = String(o - 0.2);
        requestAnimationFrame(fadeOut);
      } else {
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
      }
    })();
    document.body.style.overflow = '';
  }

  /* --- Center Stone Search Modal --- */
  window.selectedCenterStone = null;

  window.openCenterStoneModal = function () {
    var modal = document.getElementById('jc-center-stone-modal');
    if (!modal) return;
    modal.style.display = 'flex';
    modal.style.opacity = '1';
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (!modal._loaded) {
      modal._loaded = true;
      loadFeaturedCenterDiamonds();
    }
    // Bind search/reset
    setTimeout(function () {
      var searchBtn = document.getElementById('jc-cs-search-btn');
      var resetBtn = document.getElementById('jc-cs-reset-btn');
      if (searchBtn && !searchBtn._bound) {
        searchBtn._bound = true;
        searchBtn.addEventListener('click', function () { searchCenterDiamonds({ page: 1 }); });
      }
      if (resetBtn && !resetBtn._bound) {
        resetBtn._bound = true;
        resetBtn.addEventListener('click', resetCenterStoneFilters);
      }
      var sortEl = document.getElementById('jc-cs-sort');
      if (sortEl && !sortEl._bound) {
        sortEl._bound = true;
        sortEl.addEventListener('change', function () { searchCenterDiamonds({ page: 1 }); });
      }
    }, 100);
  };

  window.closeCenterStoneModal = function () {
    var modal = document.getElementById('jc-center-stone-modal');
    if (!modal) return;
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  var csCurrentPage = 1;
  var csTotalPages = 1;
  var csAllDiamonds = [];
  var CS_PER_PAGE = 30;

  function collectCsFilters() {
    var shapeEl = document.querySelector('#jc-cs-shape-options .jc-cs-shape-label.selected input');
    var shape = shapeEl ? shapeEl.value : 'round';
    var priceMin = parseFloat(document.getElementById('cs-price-min')?.value) || 0;
    var priceMax = parseFloat(document.getElementById('cs-price-max')?.value) || 50000;
    var caratMin = parseFloat(document.getElementById('cs-carat-min')?.value) || 0.5;
    var caratMax = parseFloat(document.getElementById('cs-carat-max')?.value) || 30;
    var color = Array.from(document.querySelectorAll('input[name="cs-color"]:checked')).map(function (el) { return el.value; });
    var clarity = Array.from(document.querySelectorAll('input[name="cs-clarity"]:checked')).map(function (el) { return el.value; });
    var cut = Array.from(document.querySelectorAll('input[name="cs-cut"]:checked')).map(function (el) { return el.value; });
    var cert = Array.from(document.querySelectorAll('input[name="cs-cert"]:checked')).map(function (el) { return el.value; });
    var sort = document.getElementById('jc-cs-sort')?.value || '';
    return { shape: shape, priceMin: priceMin, priceMax: priceMax, caratMin: caratMin, caratMax: caratMax, color: color, clarity: clarity, cut: cut, cert: cert, sort: sort };
  }

  function loadFeaturedCenterDiamonds() {
    var container = document.getElementById('jc-cs-results');
    if (!container) return;
    container.innerHTML = '<p style="text-align:center;padding:40px;">Loading featured diamonds...</p>';
    fetch('https://depth60-loose-proxy.onrender.com/diamonds?shape=round,oval,emerald,radiant&color=d,e,f&clarity=vvs1,vvs2,vs1&lab=igi&cut_grade=ideal&perPage=200')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 'success' && Array.isArray(data.data)) {
          csAllDiamonds = data.data;
          csCurrentPage = 1;
          csTotalPages = Math.ceil(csAllDiamonds.length / CS_PER_PAGE) || 1;
          renderCsResults();
        } else {
          container.innerHTML = '<p style="text-align:center;padding:40px;">No featured diamonds found.</p>';
        }
      })
      .catch(function (err) {
        container.innerHTML = '<p style="text-align:center;padding:40px;">Failed to load: ' + err.message + '</p>';
      });
  }

  function searchCenterDiamonds(opts) {
    opts = opts || {};
    var filters = collectCsFilters();
    var container = document.getElementById('jc-cs-results');
    if (!container) return;
    container.innerHTML = '<p style="text-align:center;padding:40px;">Searching diamonds...</p>';

    var params = new URLSearchParams();
    if (filters.shape) params.append('shape', filters.shape);
    if (filters.color && filters.color.length) params.append('color', filters.color.join(','));
    if (filters.clarity && filters.clarity.length) params.append('clarity', filters.clarity.join(','));
    if (filters.cut && filters.cut.length) params.append('cut_grade', filters.cut.join(','));
    if (filters.cert && filters.cert.length) params.append('certificate', filters.cert.join(','));
    params.append('carat_from', String(filters.caratMin));
    params.append('carat_to', String(filters.caratMax));
    params.append('price_from', String(filters.priceMin));
    params.append('price_to', String(filters.priceMax));
    params.append('perPage', '1000');
    if (filters.sort === 'priceLowHigh') params.append('sort_by', 'price_asc');
    else if (filters.sort === 'priceHighLow') params.append('sort_by', 'price_desc');
    else if (filters.sort === 'caratLowHigh') params.append('sort_by', 'carat_asc');
    else if (filters.sort === 'caratHighLow') params.append('sort_by', 'carat_desc');

    fetch('https://depth60-loose-proxy.onrender.com/diamonds?' + params.toString())
      .then(function (r) { return r.json(); })
      .then(function (response) {
        csAllDiamonds = response?.data || [];
        csCurrentPage = 1;
        csTotalPages = Math.ceil(csAllDiamonds.length / CS_PER_PAGE) || 1;
        renderCsResults();
      })
      .catch(function (err) {
        container.innerHTML = '<p style="text-align:center;padding:40px;">Server error: ' + err.message + '</p>';
      });
  }

  function renderCsResults() {
    var container = document.getElementById('jc-cs-results');
    if (!container) return;
    var start = (csCurrentPage - 1) * CS_PER_PAGE;
    var end = start + CS_PER_PAGE;
    var items = csAllDiamonds.slice(start, end);
    container.innerHTML = '';
    if (!items.length) {
      container.innerHTML = '<p style="text-align:center;padding:40px;color:#999;">No matching diamonds found.</p>';
      renderCsPagination();
      return;
    }
    items.forEach(function (d) {
      var carat = parseFloat(d.carat || d.size || 0).toFixed(2);
      var priceNum = parseFloat(d.depth60_price || 0);
      var price = isNaN(priceNum) ? 'N/A' : '$' + priceNum.toLocaleString();
      var shape = (d.shape || '').toUpperCase();
      var color = (d.color || '').toUpperCase();
      var clarity = (d.clarity || '').toUpperCase();
      var cut = (d.cut || '').toUpperCase();

      var card = document.createElement('div');
      card.className = 'jc-cs-diamond-card';
      card.innerHTML =
        '<p><strong>Shape:</strong> ' + shape + '</p>' +
        '<p><strong>Carat:</strong> ' + carat + '</p>' +
        '<p><strong>Color:</strong> ' + color + '</p>' +
        '<p><strong>Clarity:</strong> ' + clarity + '</p>' +
        '<p><strong>Cut:</strong> ' + cut + '</p>' +
        '<p><strong>Price:</strong> ' + price + '</p>' +
        (d.image_url ? '<img src="' + d.image_url + '" alt="Diamond" loading="lazy">' : '<div style="height:80px;background:#eee;border-radius:4px;margin:6px 0;"></div>') +
        '<button type="button" class="jc-cs-select-btn">Select</button>';
      card.querySelector('.jc-cs-select-btn').addEventListener('click', function () {
        selectCenterStone(d);
      });
      container.appendChild(card);
    });
    renderCsPagination();
  }

  function renderCsPagination() {
    var el = document.getElementById('jc-cs-pagination');
    if (!el) return;
    if (csTotalPages <= 1) { el.innerHTML = ''; return; }
    var showRefresh = csTotalPages <= 0;
    el.innerHTML =
      '<button id="cs-prev-btn"' + (csCurrentPage <= 1 ? ' disabled' : '') + '>Previous</button>' +
      '<span style="padding:8px 12px;">Page ' + csCurrentPage + ' of ' + csTotalPages + '</span>' +
      '<button id="cs-next-btn"' + (csCurrentPage >= csTotalPages ? ' disabled' : '') + '>Next</button>';
    document.getElementById('cs-prev-btn')?.addEventListener('click', function () {
      if (csCurrentPage > 1) { csCurrentPage--; renderCsResults(); }
    });
    document.getElementById('cs-next-btn')?.addEventListener('click', function () {
      if (csCurrentPage < csTotalPages) { csCurrentPage++; renderCsResults(); }
    });
  }

  function resetCenterStoneFilters() {
    document.querySelectorAll('#jc-cs-shape-options .jc-cs-shape-label').forEach(function (l) { l.classList.remove('selected'); });
    var defaultShape = document.querySelector('#jc-cs-shape-options input[value="round"]');
    if (defaultShape) { defaultShape.closest('.jc-cs-shape-label')?.classList.add('selected'); defaultShape.checked = true; }
    document.getElementById('cs-price-min').value = '0';
    document.getElementById('cs-price-max').value = '10000';
    document.getElementById('cs-carat-min').value = '0.5';
    document.getElementById('cs-carat-max').value = '7';
    document.querySelectorAll('#jc-cs-filters input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
    document.getElementById('jc-cs-sort').value = '';
    loadFeaturedCenterDiamonds();
  }

  function selectCenterStone(d) {
    window.selectedCenterStone = d;
    var display = document.getElementById('jc-selected-center-stone');
    if (display) {
      var carat = parseFloat(d.carat || d.size || 0).toFixed(2);
      var priceNum = parseFloat(d.depth60_price || 0);
      var price = isNaN(priceNum) ? 'N/A' : '$' + priceNum.toLocaleString();
      display.style.display = 'block';
      display.innerHTML =
        '<strong>Selected:</strong> ' + (d.shape || '').toUpperCase() + ' ' + carat + 'ct, ' +
        'Color ' + (d.color || '').toUpperCase() + ', Clarity ' + (d.clarity || '').toUpperCase() + ' — ' + price;
    }
    // Update review section
    var reviewStone = document.getElementById('review-stone-text');
    if (reviewStone) {
      reviewStone.textContent = (d.shape || '').toUpperCase() + ' ' + carat + 'ct Diamond';
    }
    closeCenterStoneModal();
  }

  // Shape selection visual toggle
  document.addEventListener('click', function (ev) {
    var label = ev.target.closest('.jc-cs-shape-label');
    if (!label) return;
    document.querySelectorAll('.jc-cs-shape-label').forEach(function (l) { l.classList.remove('selected'); });
    label.classList.add('selected');
    var inp = label.querySelector('input[type="radio"]');
    if (inp) inp.checked = true;
  });

  /* --- End Center Stone Search Modal --- */

  function renderStoneOptions(data) {
    if (!data) return;
    var stones = getSettingOptions(data);
    var $content = $('#jc-stone-options-content');
    var $count = $('#jc-stone-option-count');
    if (!$content.length) return;
    if (!stones.length) {
      latestStullerProduct = data || null;
      latestStoneGrouping = { centerStones: [], grouped: {} };
      $count.text('0 stones');
      $content.html('<div class="jc-stone-empty">No stone options available.</div>');
      return;
    }
    var groupedResult = groupSettingOptions(stones);
    latestStullerProduct = data || null;
    latestStoneGrouping = groupedResult;
    var centerStones = groupedResult.centerStones || [];
    var groupedByName = groupedResult.grouped || {};
    var totalStones = 0;
    Object.keys(groupedByName).forEach(function(k) { totalStones += groupedByName[k].length; });
    totalStones += centerStones.length;
    $count.text(totalStones + ' stone' + (totalStones === 1 ? '' : 's'));

    var html = '<div class="jc-stone-quick-set">';

    // Center stones section
    if (centerStones.length) {
      html += '<div class="jc-stone-section-label">Center Stone</div>';
      centerStones.forEach(function(stone) {
        var iconId = getStoneIconId(stone.Shape || '');
        var sizeText = formatStoneSize(stone);
        var stoneJson = encodeURIComponent(JSON.stringify(stone));
        html += '<div class="jc-stone-location-card"><div><div class="jc-stone-location-name">Center Stone</div></div><div class="jc-stone-shape-preview" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><use width="100%" height="100%" href="#' + iconId + '" xlink:href="#' + iconId + '"></use></svg></div><div><div class="jc-stone-location-size">' + sizeText + '</div><div class="jc-stone-location-meta">' + (stone.Shape || 'Diamond') + ' &middot; ' + (stone.SettingType || 'Setting') + '</div></div><div class="jc-stone-location-actions"><a href="/pages/diamond-search" class="jc-btn-center-diamond" style="padding:8px 16px;font-size:13px;">Add Center Diamond</a></div></div>';
      });
    }

    // Side & accent stones sections
    var groupNames = Object.keys(groupedByName).sort(function(a, b) {
      return getStoneGroupDisplayOrder(a, groupedByName[a]) - getStoneGroupDisplayOrder(b, groupedByName[b]);
    });
    var sideGroupNames = groupNames.filter(function(g) { return g.toLowerCase() !== 'accent' && !g.toLowerCase().match(/^accent\s*\d*$/); });
    var accentGroupNames = groupNames.filter(function(g) { return g.toLowerCase() === 'accent' || g.toLowerCase().match(/^accent\s*\d*$/); });

    if (sideGroupNames.length) {
      html += '<div class="jc-stone-section-label" style="margin-top:16px;">Side Stones</div>';
      html += sideGroupNames.map(function(groupName) { return renderStoneGroupRow(groupName, groupedByName[groupName], false); }).join('');
    }
    if (accentGroupNames.length) {
      html += '<div class="jc-stone-section-label" style="margin-top:16px;">Accent Stones</div>';
      html += accentGroupNames.map(function(groupName) { return renderStoneGroupRow(groupName, groupedByName[groupName], false); }).join('');
    }

    // Restore saved side stone selections
    groupNames.forEach(function(groupName) {
      var groupKey = normalizeStoneGroupKey(groupName);
      var saved = getSavedSideStone(groupKey);
      if (saved) {
        updateStoneSetStatus(groupKey, saved);
      }
    });

    if (!centerStones.length && !groupNames.length) {
      html += '<div class="jc-stone-empty">No stone options available.</div>';
    }

    html += '</div>';
    $content.html(html);
  }

  function render_set_with_stones(data) {
    if (!data) return;
    var setWithTbody = document.getElementById('set-with-tbody');
    var $setWithSection = $('#set-with-section');
    if (setWithTbody) {
      setWithTbody.innerHTML = '';
      var stones = data.SetWith || data.set_with || [];
      if (stones.length > 0) {
        stones.forEach(function(s) {
          var row = '<tr><td>' + (s.Quantity || s.qty || 1) + '</td><td>' + (s.Shape || s.shape || 'N/A') + '</td><td>' + (s.Size || s.size || 'N/A') + '</td><td>' + (s.SettingType || s.setting_type || 'N/A') + '</td></tr>';
          setWithTbody.insertAdjacentHTML('beforeend', row);
        });
        $setWithSection.show();
      } else {
        $setWithSection.hide();
      }
    }
    var canBeSetWithTbody = document.getElementById('can-be-set-with-tbody');
    var $canBeSetWithSection = $('#can-be-set-with-section');
    if (canBeSetWithTbody) {
      canBeSetWithTbody.innerHTML = '';
      var canStones = data.CanBeSetWith || data.can_be_set_with || [];
      if (canStones.length > 0) {
        canStones.forEach(function(s) {
          var row = '<tr><td>' + (s.Quantity || s.qty || 1) + '</td><td>' + (s.Shape || s.shape || 'N/A') + '</td><td>' + (s.Size || s.size || 'N/A') + '</td><td>' + (s.SettingType || s.setting_type || 'N/A') + '</td></tr>';
          canBeSetWithTbody.insertAdjacentHTML('beforeend', row);
        });
        $canBeSetWithSection.show();
      } else {
        $canBeSetWithSection.hide();
      }
    }
  }

  function updateMadeWith(data) {
    if (!data) return;
    var components = data.MadeWith || [];
    var $section = $('#made-with-section');
    var container = document.getElementById('made-with-container');
    if (!components.length) { $section.hide(); return; }
    if (container) container.innerHTML = '';
    components.forEach(function(item) {
      var cleanSku = (item.SKU || '').replace(/:/g, '');
      var imgUrl = 'https://meteor.stullercloud.com/das/' + cleanSku + '?$standard$';
      var displayTitle = item.Description || '';
      if (displayTitle.indexOf(' :: ') !== -1) displayTitle = displayTitle.split(' :: ')[0];
      var price = item.Price ? '$' + parseFloat(item.Price).toFixed(2) : '';
      var unit = item.UnitOfSale || 'Each';
      var itemHtml = '<div class="jc-made-with-item"><div class="jc-mw-thumb"><img src="' + imgUrl + '" alt="' + item.SKU + '"></div><div class="jc-mw-details"><a href="#" class="jc-mw-link">' + displayTitle + '</a><div class="jc-mw-sku">Item #: ' + item.SKU + '</div>' + (price ? '<div class="jc-mw-price-row"><span class="jc-mw-price">' + price + '</span> <span class="jc-mw-unit">' + unit + '</span></div>' : '') + (item.Quantity > 1 ? '<div class="jc-mw-qty">Quantity: ' + item.Quantity + '</div>' : '') + '</div></div>';
      if (container) container.insertAdjacentHTML('beforeend', itemHtml);
    });
    $section.show();
  }

  function getPageSku() {
    var skuEl = document.getElementById('item-number');
    if (skuEl && skuEl.dataset.sku) return skuEl.dataset.sku.trim();
    if (skuEl && skuEl.textContent.trim()) return skuEl.textContent.trim();
    var variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) return variantInput.value.trim();
    return '';
  }

  function setSelectedSku(sku) {
    if (!sku) return;
    var displaySku = sku.split('-')[0];
    var itemNumber = document.getElementById('item-number');
    if (itemNumber) { itemNumber.textContent = displaySku; itemNumber.dataset.sku = sku; }
    var variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value !== sku) {
      variantInput.value = sku;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function showSection(selector, show) {
    var $el = $(selector);
    if (!$el.length) return;
    $el.toggle(show);
  }

  function calculateShippingDate() {
    var date = new Date();
    var addedDays = 0;
    while (addedDays < 3) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) addedDays++;
    }
    return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  }

  function buildStullerResponseFromMetafields(product, productData) {
    var sku = productData.stuller_sku || '';
    var mf = productData;

    function getJsonField(key, def) {
      try { return JSON.parse(mf[key] || def || '[]'); } catch(e) { return []; }
    }

    var price = 0;
    if (product.variants && product.variants.length > 0) {
      price = (parseFloat(product.variants[0].price) || 0) / 100;
    }

    var images = [];
    if (Array.isArray(mf.images)) images = images.concat(mf.images);
    if (Array.isArray(mf.group_images)) {
      var existingUrls = new Set(images.map(function(i) { return i.FullUrl; }));
      mf.group_images.forEach(function(img) {
        if (!existingUrls.has(img.FullUrl)) { images.push(img); existingUrls.add(img.FullUrl); }
      });
    }

    var videos = [];
    if (Array.isArray(mf.videos)) videos = videos.concat(mf.videos);
    if (Array.isArray(mf.group_videos)) videos = videos.concat(mf.group_videos);

    var fullySetImages = Array.isArray(mf.fully_set_images) ? mf.fully_set_images : [];

    var specs = [];
    try {
      var raw = typeof mf.specifications === 'string' ? JSON.parse(mf.specifications) : (mf.specifications || []);
      specs = Array.isArray(raw) ? raw : [];
    } catch(e) {}

    var ringSizeOptions = [];
    try {
      if (typeof mf.ring_sizes === 'string' && mf.ring_sizes.indexOf('|') !== -1) {
        var pipeParts = mf.ring_sizes.split(',').map(function(p) { return p.split('|')[0]; });
        pipeParts.forEach(function(s) {
          var num = parseFloat(s);
          if (!isNaN(num)) {
            ringSizeOptions.push({ Size: num.toFixed(2), Price: { Value: 0 } });
          }
        });
      } else {
        var ringSizesRaw = typeof mf.ring_sizes === 'string' ? JSON.parse(mf.ring_sizes) : (mf.ring_sizes || []);
        if (Array.isArray(ringSizesRaw)) {
          ringSizesRaw.forEach(function(s) {
            var size = typeof s === 'object' ? (s.Size || s.size) : s;
            ringSizeOptions.push({ Size: parseFloat(size).toFixed(2), Price: { Value: 0 } });
          });
        }
      }
    } catch(e) {}

    var settingOptions = [];
    try {
      var settingRaw = typeof mf.setting_options === 'string' ? JSON.parse(mf.setting_options) : (mf.setting_options || []);
      settingOptions = Array.isArray(settingRaw) ? settingRaw : [];
    } catch(e) {}

    var canBeSetWith = [];
    try {
      var cbsRaw = typeof mf.can_be_set_with === 'string' ? JSON.parse(mf.can_be_set_with) : (mf.can_be_set_with || []);
      canBeSetWith = Array.isArray(cbsRaw) ? cbsRaw : [];
    } catch(e) {}

    var metalOpts = [];
    try {
      var metalRaw = typeof mf.metal_options === 'string' ? JSON.parse(mf.metal_options) : (mf.metal_options || []);
      metalOpts = Array.isArray(metalRaw) ? metalRaw : [];
    } catch(e) {}

    var stoneMapImage = mf.stone_map_image || '';

    var approximateRingSize = mf.approximate_ring_size || '';
    var exactRingSize = mf.exact_ring_size || '';

    var configModelId = mf.configuration_model_id || '';

    return {
      Products: [{
        SKU: sku,
        Description: product.title || '',
        GroupDescription: mf.product_nav_name || product.title || '',
        Price: { Value: price },
        PriceValue: price,
        NextDayShippingDate: new Date().toISOString(),
        RingSize: parseFloat(exactRingSize || approximateRingSize || 0),
        ConfigurationModel: {
          SettingOptions: settingOptions,
          RingSizeOptions: ringSizeOptions,
        },
        Images: images,
        GroupImages: mf.group_images || [],
        videos: videos,
        GroupVideos: mf.group_videos || [],
        FullySetImages: fullySetImages,
        Specifications: specs,
        Specs: specs,
        AdditionalDetails: [],
        AdditionalSpecs: [],
        AdditionalInfo: [],
        Weight: specs.find(function(s) { return (s.Name || '').toLowerCase().includes('weight'); }),
        WeightUnitOfMeasure: '',
        GramWeight: '',
        SetWith: [],
        CanBeSetWith: canBeSetWith,
        SettingOptions: settingOptions,
        StoneMapImage: stoneMapImage,
        MatchingBand: null,
        MadeWith: [],
        Status: 'Active',
        MetalOptions: metalOpts,
        ConfigurationModelId: configModelId,
        approximateRingSize: approximateRingSize,
        exactRingSize: exactRingSize,
      }]
    };
  }

  function fetchProductBySku(sku) {
    if (!sku) return Promise.reject('No SKU provided');

    var url = '/shopify_section/stuller_sku_api.php';

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sku: sku })
    }).then(function(res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }).then(function(data) {
      if (data && data.Products && data.Products.length) {
        return data;
      }
      throw new Error('Product not found for SKU: ' + sku);
    });
  }

  function renderStullerApiData(res) {
    showSection('#jc-matching-band-wrapper', false);
    showSection('#additional-details-section', false);
    showSection('#set-with-section', false);
    showSection('#can-be-set-with-section', false);
    showSection('#made-with-section', false);

    if (!res || !res.Products || !res.Products.length) {
      return;
    }

    var p = res.Products[0];
    var apiPrice = 0;

    if (p.Price) {
      apiPrice = p.Price.Value || p.Price || 0;
    } else if (p.PriceValue) {
      apiPrice = p.PriceValue;
    }

    if (apiPrice > 0) {
      baseProductPrice = apiPrice;
      updateTotalPriceDisplay();
    } else if (baseProductPrice === 0) {
      $('#total-price').text('Contact for Price');
    }

    function updateTotalPriceDisplay() {
      if (baseProductPrice === 0) return;
      var fingerSizeUpcharge = getFingerSizeUpcharge();
      var total = baseProductPrice + fingerSizeUpcharge;
      var formattedPrice = '$' + total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var baseFormatted = '$' + baseProductPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      $('#total-price').text(formattedPrice);
      var baseEl = document.getElementById('base-price-display');
      if (baseEl) {
        baseEl.textContent = 'Base: ' + baseFormatted;
        baseEl.style.display = '';
      }
      var modalPrice = document.getElementById('modal-total-price');
      if (modalPrice) modalPrice.textContent = formattedPrice;
    }

    function getFingerSizeUpcharge() {
      var selectEl = document.getElementById('finger-size-select');
      if (!selectEl) return 0;
      var selectedOpt = selectEl.options[selectEl.selectedIndex];
      if (!selectedOpt) return 0;
      if (selectedOpt.dataset.price) {
        return parseFloat(selectedOpt.dataset.price);
      }
      var match = selectedOpt.text.match(/\$(\d+)/);
      return match ? parseInt(match[1]) : 0;
    }

    window.updateConfiguratorTotal = updateTotalPriceDisplay;

    var shippingDate = calculateShippingDate();
    $('#jc-shipping-date').text(shippingDate);

    if (p.Description) $('#product-name').text(p.Description);

    var $sizeSelect = $('#finger-size-select');
    var currentVal = $sizeSelect.val();
    $sizeSelect.empty();

    var variants = window.PRODUCT_VARIANTS_DATA || [];
    var sizePos = window.OPTION_POSITIONS ? (window.OPTION_POSITIONS['size'] || window.OPTION_POSITIONS['ring size'] || 1) : 1;
    if (variants.length > 0) {
      var seen = {};
      variants.forEach(function(v) {
        var fingerSize = v['option' + sizePos];
        if (!fingerSize || seen[fingerSize]) return;
        seen[fingerSize] = true;
        var price = (parseFloat(v.price) || 0) / 100;
        var opt = document.createElement('option');
        opt.value = fingerSize;
        opt.textContent = fingerSize + ' ($' + price.toFixed(2) + ')';
        opt.dataset.price = price;
        if (currentVal && currentVal === fingerSize) opt.selected = true;
        $sizeSelect.el.appendChild(opt);
      });
      if (!$sizeSelect.val()) {
        var firstOpt = $sizeSelect.el.querySelector('option');
        if (firstOpt) firstOpt.selected = true;
      }
    } else if (p.RingSize > 0.00) {
      var size = parseFloat(p.RingSize).toFixed(2);
      var opt = document.createElement('option');
      opt.value = size;
      opt.textContent = size;
      opt.selected = true;
      $sizeSelect.el.appendChild(opt);
    }

    var apiImages = [];
    var apiVideos = [];

    if (Array.isArray(p.FullySetImages) && p.FullySetImages.length > 0) {
      apiImages.push.apply(apiImages, p.FullySetImages);
    } else if (Array.isArray(p.Images)) {
      apiImages.push.apply(apiImages, p.Images);
    }
    if (Array.isArray(p.GroupImages)) apiImages.push.apply(apiImages, p.GroupImages);
    if (Array.isArray(p.videos)) apiVideos.push.apply(apiVideos, p.videos.map(function(v) { return { Url: v.Url, DownloadUrl: v.DownloadUrl }; }));
    if (Array.isArray(p.GroupVideos)) apiVideos.push.apply(apiVideos, p.GroupVideos.map(function(v) { return { Url: v.Url, DownloadUrl: v.DownloadUrl }; }));

    if (apiImages.length > 0 || apiVideos.length > 0) {
      buildThumbnails({ images: apiImages, videos: apiVideos });
    }

    var matching = p.MatchingBand || (Array.isArray(p.MatchingBands) && p.MatchingBands[0]) || null;
    if (matching) {
      var series = (matching.SKU || '').split(':')[0];
      var desc = matching.Description || matching.DisplayText || '';
      var imgUrl = (matching.Images && matching.Images[0] && matching.Images[0].FullUrl) || matching.ImageUrl || matching.Image || '';
      $('#jc-mb-series-text').text(series ? 'Series: ' + series : 'Series: N/A');
      if (desc) $('#jc-mb-desc').text(desc).show(); else $('#jc-mb-desc').hide();
      if (imgUrl) $('#jc-mb-img').attr('src', imgUrl).show(); else $('#jc-mb-img').hide();
      showSection('#jc-matching-band-wrapper', true);
    }

    var $specBody = $('#spec-tbody');
    $specBody.empty();
    var specs = [];
    if (p.Weight) specs.push(['Approx. Weight', (p.Weight.Value || p.Weight.Name || '') + ' ' + (p.WeightUnitOfMeasure || '') + ' (' + (p.GramWeight || '') + ' grams)']);
    if (Array.isArray(p.Specifications)) {
      p.Specifications.forEach(function(spec) {
        if (spec.Name && spec.Value) specs.push([spec.Name, spec.Value]);
      });
    }
    if (specs.length) {
      specs.forEach(function(s) { $specBody.append('<tr><td class="jc-spec-key">' + s[0] + ':</td><td class="jc-spec-val">' + s[1] + '</td></tr>'); });
    } else {
      $specBody.append('<tr><td class="jc-spec-key">Specifications</td><td class="jc-spec-val">No specifications available.</td></tr>');
    }

    var $list = $('#additional-details-list');
    $list.empty();
    $list.append('<li>Out of Stock and Special Order items will ship when available.</li>');
    var additional = [];
    if (Array.isArray(p.AdditionalDetails)) additional.push.apply(additional, p.AdditionalDetails);
    if (Array.isArray(p.AdditionalSpecs)) additional.push.apply(additional, p.AdditionalSpecs);
    if (Array.isArray(p.AdditionalInfo)) additional.push.apply(additional, p.AdditionalInfo);
    additional.forEach(function(item) {
      if (typeof item === 'string') $list.append('<li>' + item + '</li>');
      else if (item.Description) $list.append('<li>' + item.Description + '</li>');
      else if (item.Name && item.Value) $list.append('<li>' + item.Name + ': ' + item.Value + '</li>');
    });
    showSection('#additional-details-section', true);
    renderStoneOptions(p);
    updateMadeWith(p);
    render_set_with_stones(p);
  }

  function shapeToIconId(shapeName) {
    var s = (shapeName || '').toLowerCase();
    if (s.indexOf('square') !== -1) return 'dia-faceted-princess';
    if (s.indexOf('round') !== -1) return 'dia-faceted-round';
    if (s.indexOf('oval') !== -1) return 'dia-faceted-oval';
    if (s.indexOf('princess') !== -1) return 'dia-faceted-princess';
    if (s.indexOf('emerald') !== -1) return 'dia-faceted-emerald';
    if (s.indexOf('pear') !== -1) return 'dia-faceted-pear';
    if (s.indexOf('marquise') !== -1) return 'dia-faceted-marquise';
    if (s.indexOf('cushion') !== -1) return 'dia-faceted-cushion';
    if (s.indexOf('asscher') !== -1) return 'dia-faceted-asscher';
    if (s.indexOf('heart') !== -1) return 'dia-faceted-heart';
    if (s.indexOf('trillion') !== -1) return 'dia-faceted-trillion';
    if (s.indexOf('radiant') !== -1) return 'dia-faceted-radiant';
    if (s.indexOf('baguette') !== -1) return 'dia-faceted-straight-baguette';
    if (s.indexOf('hexagon') !== -1) return 'dia-faceted-hexagon';
    if (s.indexOf('octagon') !== -1) return 'dia-faceted-octagon';
    if (s.indexOf('rectangle') !== -1) return 'dia-faceted-rectangle';
    if (s.indexOf('shield') !== -1) return 'dia-faceted-shield';
    if (s.indexOf('kite') !== -1) return 'dia-faceted-kite';
    if (s.indexOf('pentagon') !== -1) return 'dia-faceted-pentagon';
    if (s.indexOf('trapezoid') !== -1) return 'dia-faceted-trapezoid';
    if (s.indexOf('triangle') !== -1) return 'dia-faceted-triangle';
    if (s.indexOf('barrel') !== -1) return 'dia-faceted-barrel';
    if (s.indexOf('briolette') !== -1) return 'dia-faceted-briolette';
    if (s.indexOf('half-moon') !== -1 || s.indexOf('half moon') !== -1) return 'dia-faceted-half-moon';
    if (s.indexOf('checkerboard') !== -1) return 'dia-faceted-checkerboard';
    if (s.indexOf('cadillac') !== -1) return 'dia-faceted-cadillac';
    return 'dia-faceted-round';
  }

  function buildShapeGrid(entries) {
    var grid = document.getElementById('shape-grid');
    if (!grid) return null;
    grid.innerHTML = '';

    var activeShapeEl = document.querySelector('.jc-shape-btn.active');
    var prevShape = activeShapeEl ? activeShapeEl.dataset.shape.toLowerCase() : '';

    var uniqueShapes = [], seenShapes = {};
    entries.forEach(function(e) {
      var shape = (e.shape || '').trim();
      if (shape && !seenShapes[shape.toLowerCase()]) {
        seenShapes[shape.toLowerCase()] = true;
        uniqueShapes.push(shape);
      }
    });

    if (!uniqueShapes.length) return null;

    var activeFound = false;
    uniqueShapes.forEach(function(shape, idx) {
      var iconId = shapeToIconId(shape);
      var btn = document.createElement('button');
      btn.className = 'jc-shape-btn';
      btn.dataset.shape = shape;
      btn.setAttribute('aria-label', shape + ' cut');
      btn.setAttribute('title', shape);
      btn.innerHTML = '<span class="jc-shape-icon"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><use width="40" height="40" href="#' + iconId + '"></use></svg></span><span class="jc-shape-label">' + shape + '</span>';
      if (shape.toLowerCase() === prevShape) {
        btn.classList.add('active');
        activeFound = true;
      }
      grid.appendChild(btn);
    });

    if (!activeFound) {
      var first = grid.querySelector('.jc-shape-btn');
      if (first) first.classList.add('active');
    }

    var activeBtn = grid.querySelector('.jc-shape-btn.active');
    return activeBtn ? activeBtn.dataset.shape.toLowerCase() : (uniqueShapes.length ? uniqueShapes[0].toLowerCase() : null);
  }

  function renderShapesAndSizesFromMetafields(initialData) {
    var map = window.SERIES_SKU_MAP || [];

    refreshMetalOptions();

    if (!map.length) {
      var shape = initialData.stone_shape || '';
      if (shape) buildShapeGrid([{ shape: shape }]);

      var stoneSize = initialData.stone_size || '';
      var sizeSelect = document.getElementById('stone-size-select');
      if (sizeSelect && stoneSize) {
        sizeSelect.innerHTML = '';
        var opt = document.createElement('option');
        opt.value = stoneSize;
        opt.textContent = stoneSize;
        opt.selected = true;
        sizeSelect.appendChild(opt);
      }
      return;
    }

    var state = getSelectedJewelryState();
    var stateFiltered = state ? map.filter(function(e) { return (e.jewelry_state || '') === state; }) : map;
    if (!stateFiltered.length) return;

    var metal = document.getElementById('metal-select')?.value || '';
    var metalFiltered = metal ? stateFiltered.filter(function(e) { return (e.metal || '') === metal; }) : stateFiltered;
    if (!metalFiltered.length) metalFiltered = stateFiltered;

    buildShapeGrid(metalFiltered);
    updateStoneSizeSelectForActiveShape();
  }

  function refreshMetalOptions() {
    var state = getSelectedJewelryState();
    var map = window.SERIES_SKU_MAP || [];
    var seen = {}, metals = [];

    if (map.length) {
      var filtered = state ? map.filter(function(e) { return (e.jewelry_state || '') === state; }) : map;
      filtered.forEach(function(e) {
        if (e.metal && !seen[e.metal]) {
          seen[e.metal] = true;
          metals.push({ Value: e.metal, Label: e.metal });
        }
      });
    } else {
      var metalPos = window.OPTION_POSITIONS ? (window.OPTION_POSITIONS['metal'] || window.OPTION_POSITIONS['metal quality'] || 0) : 0;
      if (metalPos) {
        var variants = window.PRODUCT_VARIANTS_DATA || [];
        variants.forEach(function(v) {
          var m = v['option' + metalPos];
          if (m && !seen[m]) {
            seen[m] = true;
            metals.push({ Value: m, Label: m });
          }
        });
      }
      var initData = window.INITIAL_PRODUCT_DATA;
      if (!metals.length && initData && initData.metal) {
        metals.push({ Value: initData.metal, Label: initData.metal });
      }
    }

    var metalSelect = document.getElementById('metal-select');
    if (!metalSelect) return;
    if (!metals.length) return;
    metalSelect.innerHTML = '';
    metals.forEach(function(m) {
      var opt = document.createElement('option');
      opt.value = m.Value;
      opt.textContent = m.Label;
      metalSelect.appendChild(opt);
    });
  }

  // ── Jewelry state ──

  function getSelectedJewelryState() {
    var bar = document.getElementById('jc-jewelry-state-bar');
    if (!bar) return window.JEWELRY_STATE || '';
    var active = bar.querySelector('.jc-state-btn.active');
    if (active) return active.dataset.state;
    var select = bar.querySelector('.jc-select');
    if (select) return select.value;
    return window.JEWELRY_STATE || '';
  }

  function jewelryStateLabel(state) {
    return state === 'Mountings' ? 'Unset' : state;
  }

  function renderJewelryStateSelector() {
    var section = document.getElementById('jc-jewelry-state-section');
    var bar = document.getElementById('jc-jewelry-state-bar');
    if (!bar || !section) return;
    var states = window.SERIES_JEWELRY_STATES || [];
    var current = window.JEWELRY_STATE || '';
    if (!states.length) { section.style.display = 'none'; return; }
    section.style.display = '';
    bar.innerHTML = '';
    if (states.length === 1) {
      var val = document.createElement('span');
      val.className = 'jc-state-value';
      val.textContent = jewelryStateLabel(states[0]);
      bar.appendChild(val);
    } else if (states.length === 2) {
      states.forEach(function(s) {
        var btn = document.createElement('button');
        btn.className = 'jc-state-btn' + (s === current ? ' active' : '');
        btn.dataset.state = s;
        btn.textContent = jewelryStateLabel(s);
        btn.addEventListener('click', function() {
          if (btn.classList.contains('active')) return;
          bar.querySelectorAll('.jc-state-btn').forEach(function(b) { b.classList.remove('active'); });
          btn.classList.add('active');
          onJewelryStateChange(s);
        });
        bar.appendChild(btn);
      });
    } else {
      var wrap = document.createElement('div');
      wrap.className = 'jc-select-wrap';
      var select = document.createElement('select');
      select.className = 'jc-select';
      states.forEach(function(s) {
        var opt = document.createElement('option');
        opt.value = s;
        opt.textContent = jewelryStateLabel(s);
        if (s === current) opt.selected = true;
        select.appendChild(opt);
      });
      select.addEventListener('change', function() { onJewelryStateChange(select.value); });
      wrap.appendChild(select);
      var icon = document.createElement('i');
      icon.className = 'fa fa-chevron-down jc-select-icon';
      wrap.appendChild(icon);
      bar.appendChild(wrap);
    }
  }

  function onJewelryStateChange(state) {
    var map = window.SERIES_SKU_MAP || [];

    refreshMetalOptions();

    if (!map.length) {
      var initData = window.INITIAL_PRODUCT_DATA;
      var shape = initData ? initData.stone_shape : '';
      if (shape) buildShapeGrid([{ shape: shape }]);
      updateStoneSizeSelectForActiveShape();
      saveSelections();
      updateConfigurator();
      return;
    }

    var filtered = map.filter(function(e) { return (e.jewelry_state || '') === state; });

    var metal = document.getElementById('metal-select')?.value || '';
    var metalFiltered = metal ? filtered.filter(function(e) { return (e.metal || '') === metal; }) : filtered;
    if (!metalFiltered.length) metalFiltered = filtered;

    buildShapeGrid(metalFiltered);
    updateStoneSizeSelectForActiveShape();

    saveSelections();
    updateConfigurator();
  }

  function refreshFromInitialData() {
    var initialData = window.INITIAL_PRODUCT_DATA;
    if (!initialData) return;

    var engravingSection = document.getElementById('engraving-section');
    if (engravingSection) {
      engravingSection.style.display = initialData.engraving_options ? '' : 'none';
    }

    renderShapesAndSizesFromMetafields(initialData);
    renderJewelryStateSelector();

    if (baseProductPrice === 0 && initialData.stuller_base_price) {
      baseProductPrice = parseFloat(initialData.stuller_base_price) || 0;
      updateTotalPriceDisplay();
    }

    var sku = initialData.stuller_sku || getPageSku();
    if (sku) setSelectedSku(sku);

    var product = { title: initialData.product_title || window.PRODUCT_TITLE || '' };
    var meta = {};
    Object.keys(initialData).forEach(function(key) {
      if (key === 'product_title' || key === 'product_handle' || key === 'product_id') return;
      meta[key] = initialData[key];
    });

    var stullerResponse = buildStullerResponseFromMetafields(
      { title: initialData.product_title || '', variants: window.PRODUCT_VARIANTS_DATA || [] },
      meta
    );
    renderStullerApiData(stullerResponse);
  }

  function updateConfigurator() {
    $('#total-price').html('<span class="jc-price-skeleton"></span>');
    var baseEl = document.getElementById('base-price-display');
    if (baseEl) baseEl.style.display = 'none';
    $('#jc-shipping-date').text('Calculating...');
    showLoader(true);

    var seriesSkuMap = window.SERIES_SKU_MAP || [];
    var selectedJewelryState = getSelectedJewelryState();
    var shapeBtn = document.querySelector('.jc-shape-btn.active');
    var selectedShape = shapeBtn ? shapeBtn.dataset.shape : '';
    var selectedSize = document.getElementById('stone-size-select')?.value;
    var selectedMetal = document.getElementById('metal-select')?.value;

    var targetSku = '';
    if (selectedShape && selectedSize) {
      var normShape = selectedShape.toString().toLowerCase().trim();
      var normSize = selectedSize.toString().toLowerCase().trim();
      var normState = (selectedJewelryState || '').toLowerCase().trim();
      var normMetal = (selectedMetal || '').toLowerCase().trim();
      for (var i = 0; i < seriesSkuMap.length; i++) {
        var entry = seriesSkuMap[i];
        var entryShape = (entry.shape || '').toString().toLowerCase().trim();
        var entrySize = (entry.size || '').toString().toLowerCase().trim();
        var entryState = (entry.jewelry_state || '').toLowerCase().trim();
        var entryMetal = (entry.metal || '').toLowerCase().trim();
        if (entryShape === normShape && entrySize === normSize && (!normState || entryState === normState || !entryState) && entryMetal === normMetal) {
          targetSku = entry.sku;
          break;
        }
      }
      // Fallback: if no exact metal match, try any metal
      if (!targetSku) {
        for (var i = 0; i < seriesSkuMap.length; i++) {
          var entry = seriesSkuMap[i];
          var entryShape = (entry.shape || '').toString().toLowerCase().trim();
          var entrySize = (entry.size || '').toString().toLowerCase().trim();
          var entryState = (entry.jewelry_state || '').toLowerCase().trim();
          if (entryShape === normShape && entrySize === normSize && (!normState || entryState === normState || !entryState)) {
            targetSku = entry.sku;
            break;
          }
        }
      }
    }

    if (!targetSku) {
      var matchedVariant = findMatchingVariant();
      if (matchedVariant) {
        targetSku = matchedVariant.sku;
        var actualShape = matchedVariant['option' + shapePos];
        var actualSize = matchedVariant['option' + sizePos];
        var actualMetal = matchedVariant['option' + metalPos];
        if (actualShape) {
          document.querySelectorAll('.jc-shape-btn').forEach(function(btn) { btn.classList.remove('active'); });
          document.querySelectorAll('.jc-shape-btn').forEach(function(btn) {
            var btnShape = btn.dataset.shape.toLowerCase();
            if (actualShape.toLowerCase().includes(btnShape) || btnShape.includes(actualShape.toLowerCase())) {
              btn.classList.add('active');
            }
          });
          if (!document.querySelector('.jc-shape-btn.active')) {
            var firstBtn = document.querySelector('.jc-shape-btn');
            if (firstBtn) firstBtn.classList.add('active');
          }
        }
        var stoneSizeSelect = document.getElementById('stone-size-select');
        if (actualSize && stoneSizeSelect && stoneSizeSelect.value !== actualSize) stoneSizeSelect.value = actualSize;
        var metalSelect = document.getElementById('metal-select');
        if (actualMetal && metalSelect && metalSelect.value !== actualMetal) metalSelect.value = actualMetal;
      }
    }

    if (targetSku) {
      saveSelections();
      setSelectedSku(targetSku);

      showStepLoader(true);
      fetchProductBySku(targetSku)
        .then(function(response) {
          renderStullerApiData(response);
          showLoader(false);
          showStepLoader(false);
        })
        .catch(function() {
          refreshFromInitialData();
          showLoader(false);
          showStepLoader(false);
        });
    } else {
      refreshFromInitialData();
      showLoader(false);
    }
  }

  function saveSelections() {
    var shapeBtn = document.querySelector('.jc-shape-btn.active');
    var selections = {
      jewelryState: getSelectedJewelryState(),
      shape: shapeBtn ? shapeBtn.dataset.shape : undefined,
      size: document.getElementById('stone-size-select')?.value,
      metal: document.getElementById('metal-select')?.value,
      fingerSize: document.getElementById('finger-size-select')?.value,
    };
    sessionStorage.setItem('jc_user_selections', JSON.stringify(selections));
  }

  function loadSelections() {
    var saved = sessionStorage.getItem('jc_user_selections');
    if (saved) {
      try {
        var selections = JSON.parse(saved);
        if (selections.shape) {
          document.querySelectorAll('.jc-shape-btn').forEach(function(btn) { btn.classList.remove('active'); });
          var targetBtn = document.querySelector('.jc-shape-btn[data-shape="' + selections.shape + '"]');
          if (targetBtn) targetBtn.classList.add('active');
        }
        if (selections.size) {
          var sizeSelect = document.getElementById('stone-size-select');
          if (sizeSelect) sizeSelect.value = selections.size;
        }
        if (selections.metal) {
          var metalSelect = document.getElementById('metal-select');
          if (metalSelect) metalSelect.value = selections.metal;
        }
        if (selections.fingerSize) {
          var fingerSelect = document.getElementById('finger-size-select');
          if (fingerSelect) fingerSelect.value = selections.fingerSize;
        }
      } catch(e) { console.error("Error loading selections:", e); }
    }
  }

  var updateStoneSizeSelectForActiveShape;

  $(function() {
    // --- Navigation ---
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.jc-next-btn');
      if (btn) { var nextStep = btn.dataset.next; if (nextStep) updateStepper(parseInt(nextStep)); return; }
      btn = e.target.closest('.jc-back-btn');
      if (btn) { var backStep = btn.dataset.back; if (backStep) updateStepper(parseInt(backStep)); return; }
    });

    // --- Metal change ---
    var metalSelect = document.getElementById('metal-select');
    if (metalSelect) {
      metalSelect.addEventListener('change', function() {
        lastPriority = 'metal';
        var map = window.SERIES_SKU_MAP || [];

        if (!map.length) {
          var initData = window.INITIAL_PRODUCT_DATA;
          var shape = initData ? initData.stone_shape : '';
          if (shape) buildShapeGrid([{ shape: shape }]);
          updateStoneSizeSelectForActiveShape();
          saveSelections();
          updateConfigurator();
          return;
        }

        var state = getSelectedJewelryState();
        var stateFiltered = state ? map.filter(function(e) { return (e.jewelry_state || '') === state; }) : map;
        var metal = metalSelect.value;
        var metalFiltered = metal ? stateFiltered.filter(function(e) { return (e.metal || '') === metal; }) : stateFiltered;
        if (!metalFiltered.length) metalFiltered = stateFiltered;
        buildShapeGrid(metalFiltered);
        updateStoneSizeSelectForActiveShape();
        saveSelections();
        updateConfigurator();
      });
    }

    // --- Stone size change ---
    var stoneSizeSelect = document.getElementById('stone-size-select');
    if (stoneSizeSelect) {
      stoneSizeSelect.addEventListener('change', function() { lastPriority = 'size'; saveSelections(); updateConfigurator(); });
    }

    // --- Finger size change ---
    var fingerSizeSelect = document.getElementById('finger-size-select');
    if (fingerSizeSelect) {
      fingerSizeSelect.addEventListener('change', function() { saveSelections(); if (window.updateConfiguratorTotal) window.updateConfiguratorTotal(); else updateConfigurator(); });
    }

    // --- Shape selector ---
    document.addEventListener('click', function(e) {
      var shapeBtn = e.target.closest('.jc-shape-btn');
      if (!shapeBtn) return;
      lastPriority = 'shape';
      document.querySelectorAll('.jc-shape-btn').forEach(function(btn) { btn.classList.remove('active'); });
      shapeBtn.classList.add('active');
      updateStoneSizeSelectForActiveShape();
      saveSelections();
      updateConfigurator();
    });

    updateStoneSizeSelectForActiveShape = function() {
      var sizeSelect = document.getElementById('stone-size-select');
      if (!sizeSelect) return;

      var map = window.SERIES_SKU_MAP || [];

      if (!map.length) {
        var stoneSize = window.INITIAL_PRODUCT_DATA ? window.INITIAL_PRODUCT_DATA.stone_size : '';
        if (stoneSize) {
          sizeSelect.innerHTML = '';
          var opt = document.createElement('option');
          opt.value = stoneSize;
          opt.textContent = stoneSize;
          opt.selected = true;
          sizeSelect.appendChild(opt);
        }
        return;
      }

      var activeBtn = document.querySelector('.jc-shape-btn.active');
      if (!activeBtn) return;
      var activeShape = activeBtn.dataset.shape.toLowerCase();
      var state = getSelectedJewelryState();
      var metal = document.getElementById('metal-select')?.value || '';
      var filtered = map.filter(function(e) {
        if (state && (e.jewelry_state || '') !== state) return false;
        if (metal && (e.metal || '') !== metal) return false;
        return true;
      });

      var matched = [];
      filtered.forEach(function(e) {
        var shape = (e.shape || '').trim().toLowerCase();
        var size = (e.size || '').trim();
        if (shape === activeShape && size && matched.indexOf(size) === -1) matched.push(size);
      });

      if (!matched.length) return;
      sizeSelect.innerHTML = '';
      matched.forEach(function(s) {
        var opt = document.createElement('option');
        opt.value = s;
        opt.textContent = s;
        sizeSelect.appendChild(opt);
      });
    };

    updateStoneSizeSelectForActiveShape();

    // --- Thumb navigation ---
    var thumbLeft = document.getElementById('thumb-left');
    if (thumbLeft) {
      thumbLeft.addEventListener('click', function() {
        var track = document.getElementById('thumb-track');
        if (!track) return;
        track.scrollBy({ left: -180, behavior: 'smooth' });
        setTimeout(updateThumbNavButtons, 220);
      });
    }
    var thumbRight = document.getElementById('thumb-right');
    if (thumbRight) {
      thumbRight.addEventListener('click', function() {
        var track = document.getElementById('thumb-track');
        if (!track) return;
        track.scrollBy({ left: 180, behavior: 'smooth' });
        setTimeout(updateThumbNavButtons, 220);
      });
    }
    var thumbTrack = document.getElementById('thumb-track');
    if (thumbTrack) thumbTrack.addEventListener('scroll', updateThumbNavButtons);

    // --- Keyboard nav ---
    document.addEventListener('keydown', function(e) { if (e.key === 'ArrowLeft') showMedia(currentIndex - 1); if (e.key === 'ArrowRight') showMedia(currentIndex + 1); });

    // --- Touch swipe ---
    var touchStartX = 0;
    var viewer = document.getElementById('main-viewer');
    if (viewer) {
      viewer.addEventListener('touchstart', function(e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
      viewer.addEventListener('touchend', function(e) { var dx = e.changedTouches[0].screenX - touchStartX; if (Math.abs(dx) > 40) dx < 0 ? showMedia(currentIndex + 1) : showMedia(currentIndex - 1); }, { passive: true });
    }

    // --- Full details scroll ---
    var btnFullDetails = document.getElementById('btn-full-details');
    if (btnFullDetails) {
      btnFullDetails.addEventListener('click', function() {
        var specsEl = document.getElementById('specifications');
        if (specsEl) {
          var top = specsEl.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    }

    // --- Media modal ---
    window.openMediaModal = function() {
      var modal = document.getElementById('jc-media-modal');
      if (!modal) return;
      var productName = document.getElementById('product-name')?.textContent || 'Product View';
      document.getElementById('jc-modal-title').textContent = productName;
      renderModalThumbs();
      renderModalMedia(currentIndex);
      modal.style.display = 'flex';
      modal.style.opacity = '0';
      (function fadeIn() {
        var o = parseFloat(modal.style.opacity);
        if (o < 1) { modal.style.opacity = String(o + 0.2); requestAnimationFrame(fadeIn); }
      })();
      document.body.style.overflow = 'hidden';
    };
    window.closeMediaModal = function() {
      var modal = document.getElementById('jc-media-modal');
      if (!modal) return;
      (function fadeOut() {
        var o = parseFloat(modal.style.opacity);
        if (o > 0) { modal.style.opacity = String(o - 0.2); requestAnimationFrame(fadeOut); }
        else { modal.style.display = 'none'; }
      })();
      document.body.style.overflow = '';
    };

    function renderModalThumbs() {
      var container = document.getElementById('jc-modal-thumbs');
      if (!container) return;
      container.innerHTML = '';
      mediaItems.forEach(function(item, idx) {
        var isActive = (idx === currentIndex) ? 'active' : '';
        var thumbUrl = item.thumb || item.url || '';
        var thumb = document.createElement('div');
        thumb.className = 'jc-modal-thumb-node ' + isActive;
        thumb.dataset.index = idx;
        thumb.innerHTML = '<img src="' + thumbUrl + '" alt="Thumbnail ' + idx + '">';
        thumb.addEventListener('click', function() { renderModalMedia(idx); });
        container.appendChild(thumb);
      });
    }

    function renderModalMedia(index) {
      currentIndex = index;
      var item = mediaItems[currentIndex];
      var wrap = document.getElementById('jc-modal-media-wrap');
      if (!wrap) return;
      wrap.innerHTML = '';
      document.querySelectorAll('.jc-modal-thumb-node').forEach(function(n) { n.classList.remove('active'); });
      var activeThumb = document.querySelector('.jc-modal-thumb-node[data-index="' + currentIndex + '"]');
      if (activeThumb) activeThumb.classList.add('active');
      if (item.type === 'video') {
        wrap.innerHTML = '<video src="' + item.url + '" controls autoplay loop style="max-width:100%; max-height:100%;"></video>';
      } else {
        var imgUrl = item.zoom || item.url;
        wrap.innerHTML = '<img src="' + imgUrl + '" alt="Product Image" style="max-width:100%; max-height:100%; object-fit:contain;">';
      }
      showMedia(currentIndex, false);
    }

    window.modalPrev = function() { var newIdx = currentIndex - 1; if (newIdx < 0) newIdx = mediaItems.length - 1; renderModalMedia(newIdx); };
    window.modalNext = function() { var newIdx = currentIndex + 1; if (newIdx >= mediaItems.length) newIdx = 0; renderModalMedia(newIdx); };

    var mediaModal = document.getElementById('jc-media-modal');
    if (mediaModal) {
      mediaModal.addEventListener('click', function(e) {
        if (e.target.classList.contains('jc-media-modal')) closeMediaModal();
      });
    }

    // --- Zoom ---
    var $viewer = $('#main-viewer');
    if ($viewer.el) {
      $viewer.css('cursor', 'zoom-in');
      $viewer.el.addEventListener('click', function(e) {
        if (!e.target.closest('.jc-media-counter')) openMediaModal();
      });
      $viewer.el.addEventListener('mouseenter', function() {
        if (mediaItems[currentIndex] && mediaItems[currentIndex].type === 'image') {
          var zoomBox = document.getElementById('jc-zoom-box');
          if (zoomBox) { zoomBox.style.display = ''; zoomBox.style.opacity = '0'; (function fade() { var o = parseFloat(zoomBox.style.opacity); if (o < 1) { zoomBox.style.opacity = String(o + 0.2); requestAnimationFrame(fade); } })(); }
        }
      });
      $viewer.el.addEventListener('mousemove', function(e) {
        if (mediaItems[currentIndex] && mediaItems[currentIndex].type === 'image') {
          var rect = this.getBoundingClientRect();
          var x = e.clientX - rect.left;
          var y = e.clientY - rect.top;
          var xPercent = (x / rect.width) * 100;
          var yPercent = (y / rect.height) * 100;
          var zoomImg = document.getElementById('jc-zoom-img');
          if (zoomImg) { zoomImg.style.left = '-' + (xPercent * 1.5) + '%'; zoomImg.style.top = '-' + (yPercent * 1.5) + '%'; }
        }
      });
      $viewer.el.addEventListener('mouseleave', function() {
        var zoomBox = document.getElementById('jc-zoom-box');
        if (zoomBox) { (function fade() { var o = parseFloat(zoomBox.style.opacity); if (o > 0) { zoomBox.style.opacity = String(o - 0.2); requestAnimationFrame(fade); } else { zoomBox.style.display = 'none'; } })(); }
      });
    }

    // --- Engraving char counter ---
    var engravingInput = document.getElementById('engraving-text');
    var engravingCount = document.getElementById('engraving-char-count');
    if (engravingInput && engravingCount) {
      engravingInput.addEventListener('input', function() {
        var len = engravingInput.value.length;
        engravingCount.textContent = len + ' / 20';
      });
    }

    // --- Stone location modal events ---
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.jc-stone-set-btn');
      if (btn) {
        e.preventDefault();
        var encodedKey = btn.getAttribute('data-stone-group-key') || '';
        var selectedGroupKey = encodedKey ? decodeURIComponent(encodedKey) : '';
        openStoneLocationModal(selectedGroupKey);
        return;
      }
      btn = e.target.closest('.jc-stone-modal-select-btn');
      if (btn) {
        e.preventDefault();
        var stone = getSelectedStoneFromEl(btn);
        stoneModalState.selectedStone = stone;
        stoneModalState.selectedGroupKey = stone.groupKey;
        stoneModalState.filters = { cut: '', color: '', quality: '' };
        stoneModalState.page = 1;
        stoneModalState.perPage = 6;
        loadStoneSearchPage(1);
        return;
      }
      btn = e.target.closest('.jc-search-filter-select');
      if (btn) {
        var filterType = btn.dataset.filter;
        if (filterType) {
          stoneModalState.filters[filterType] = btn.value || '';
          loadStoneSearchPage(1);
        }
        return;
      }
      btn = e.target.closest('.jc-stone-search-reset');
      if (btn) { stoneModalState.filters = { cut: '', color: '', quality: '' }; loadStoneSearchPage(1); return; }
      btn = e.target.closest('.jc-stone-results-set-btn');
      if (btn) {
        var diamondId = btn.getAttribute('data-id');
        var allResults = stoneModalState.baseResults || [];
        var diamond = allResults.find(function(r) { return String(r.id) === String(diamondId); });
        if (diamond) {
          var groupKey = stoneModalState.selectedStone ? stoneModalState.selectedStone.groupKey : '';
          if (groupKey) {
            try { sessionStorage.setItem('selected_side_stone_' + groupKey, JSON.stringify(diamond)); } catch(e) {}
          }
          closeStoneLocationModal();
          var stoneGroupKey = stoneModalState.selectedStone ? stoneModalState.selectedStone.groupKey : '';
          if (stoneGroupKey) {
            updateStoneSetStatus(stoneGroupKey, diamond);
          }
        }
        return;
      }
      btn = e.target.closest('.jc-stone-pagination-btn');
      if (btn) { var page = parseInt(btn.getAttribute('data-page') || '0', 10); if (page && page !== stoneModalState.page) loadStoneSearchPage(page); return; }
      btn = e.target.closest('.jc-stone-modal-back-btn');
      if (btn) { renderStoneLocationListView(stoneModalState.selectedGroupKey || ''); return; }
      btn = e.target.closest('.jc-stone-use-link, .jc-stone-modal-use-link');
      if (btn) {
        e.preventDefault();
        var stoneData = getSelectedStoneFromEl(btn);
        var modal = document.getElementById('jc-stone-location-modal');
        var modalIsOpen = modal && modal.style.display !== 'none' && modal.style.display !== '';
        if (!modalIsOpen) openStoneLocationModal(stoneData.groupKey || '');
        stoneModalState.selectedStone = stoneData;
        stoneModalState.selectedGroupKey = stoneData.groupKey;
        renderUseMyStoneView(stoneData);
        return;
      }
      btn = e.target.closest('.jc-use-stone-save');
      if (btn) {
        if (!stoneModalState.selectedStone) return;
        var valueEl = document.getElementById('jc-use-stone-value');
        var value = (valueEl ? valueEl.value : '0').toString();
        useMyStoneValues[stoneModalState.selectedStone.groupKey] = value;
        renderStoneLocationListView(stoneModalState.selectedGroupKey || '');
        return;
      }
      btn = e.target.closest('.jc-use-stone-cancel');
      if (btn) { renderStoneLocationListView(stoneModalState.selectedGroupKey || ''); return; }
      btn = e.target.closest('.jc-stone-location-modal-close, #jc-stone-location-modal-done');
      if (btn) { closeStoneLocationModal(); return; }
    });

    var stoneLocationModal = document.getElementById('jc-stone-location-modal');
    if (stoneLocationModal) {
      stoneLocationModal.addEventListener('click', function(e) {
        if (e.target.id === 'jc-stone-location-modal') closeStoneLocationModal();
      });
    }

    // --- Cart modal ---
    var cartBtn = document.getElementById('btn-add-to-cart');
    var modal = document.getElementById('cartModal');
    var closeBtn = document.getElementById('closeModal');
    if (cartBtn && modal && closeBtn) {
      cartBtn.onclick = function() {
        var livePrice = document.getElementById('total-price')?.textContent;
        var liveDate = document.getElementById('jc-shipping-date')?.textContent;
        document.getElementById('modal-total-price').textContent = livePrice;
        document.getElementById('modal-shipping-date').textContent = liveDate;
        modal.style.display = "flex";
        document.body.style.overflow = "hidden";
      };
      closeBtn.onclick = function() { modal.style.display = "none"; document.body.style.overflow = ""; };
      window.addEventListener('click', function(event) { if (event.target == modal) { modal.style.display = "none"; document.body.style.overflow = ""; } });
      var modalAddBtn = document.getElementById('modal-add-to-cart-btn');
      if (modalAddBtn) {
        modalAddBtn.onclick = function() {
          this.disabled = true;
          this.textContent = 'Adding...';
          var qty = parseInt(document.getElementById('modal-qty')?.value) || 1;
          var specialInstructions = document.getElementById('modal-special-instructions')?.value || '';
          var customerNotes = document.getElementById('modal-customer-notes')?.value || '';
          var shapeBtn = document.querySelector('.jc-shape-btn.active');
          var selectedShape = shapeBtn ? shapeBtn.dataset.shape : 'N/A';
          var selectedSize = document.getElementById('stone-size-select')?.value || 'N/A';
          var selectedMetal = document.getElementById('metal-select')?.value || 'N/A';
          var selectedFingerSize = document.getElementById('finger-size-select')?.value || 'N/A';
          var matchedVariant = findMatchingVariant();
          if (!matchedVariant) {
            alert('Selected variant not found.');
            this.disabled = false;
            this.textContent = 'Add to Cart';
            return;
          }
          var engravingText = document.getElementById('engraving-text')?.value || '';
          var properties = {
            'Primary Stone Shape': selectedShape,
            'Primary Stone Size': selectedSize,
            'Metal Quality': selectedMetal,
            'Finger Size': selectedFingerSize,
            'Engraving': engravingText,
            'Special Instructions': specialInstructions,
            'Customer Notes': customerNotes
          };
          // Add selected center diamond info
          if (window.selectedCenterStone) {
            var cd = window.selectedCenterStone;
            properties['Center Diamond Shape'] = cd.shape || '';
            properties['Center Diamond Carat'] = cd.carat || cd.size || '';
            properties['Center Diamond Color'] = cd.color || '';
            properties['Center Diamond Clarity'] = cd.clarity || '';
            properties['Center Diamond Cut'] = cd.cut || '';
            properties['Center Diamond Price'] = cd.depth60_price || '';
            properties['Center Diamond Cert'] = cd.certificate || cd.lab || '';
            properties['Center Diamond SKU'] = cd.sku || cd.stock_number || '';
          }
          // Add "Use My Stone" values to cart properties
          Object.keys(useMyStoneValues).forEach(function(key) {
            if (useMyStoneValues[key] && parseFloat(useMyStoneValues[key]) > 0) {
              properties['Stone Value (' + key + ')'] = '$' + parseFloat(useMyStoneValues[key]).toFixed(2);
            }
          });
          // Add selected side stone info
          var sideStoneGroups = latestStoneGrouping.grouped || {};
          Object.keys(sideStoneGroups).forEach(function(groupName) {
            var groupKey = normalizeStoneGroupKey(groupName);
            var saved = getSavedSideStone(groupKey);
            if (saved) {
              properties['Side Stone (' + groupName + ')'] = saved.serial_number || (saved.shape + ' ' + (saved.carat || saved.size_ct || ''));
            }
          });
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: matchedVariant.id, quantity: qty, properties: properties }] })
          })
          .then(function(response) { if (!response.ok) throw new Error('Network response was not ok'); return response.json(); })
          .then(function(data) { window.location.href = '/cart'; })
          .catch(function(error) {
            console.error('Error:', error);
            alert('There was an error adding to cart.');
            if (modalAddBtn) { modalAddBtn.disabled = false; modalAddBtn.textContent = 'Add to Cart'; }
          });
        };
      }
    }

    // --- Initialize ---
    function boot() {
      loadSelections();

      if (window.INITIAL_PRODUCT_DATA) {
        refreshFromInitialData();

        var saved = sessionStorage.getItem('jc_user_selections');
        if (saved) {
          try {
            var sel = JSON.parse(saved);
            if (sel.jewelryState && window.SERIES_JEWELRY_STATES && window.SERIES_JEWELRY_STATES.length > 1) {
              onJewelryStateChange(sel.jewelryState);
              var states = window.SERIES_JEWELRY_STATES || [];
              if (states.length === 2) {
                document.querySelectorAll('.jc-state-btn').forEach(function(b) { b.classList.toggle('active', b.dataset.state === sel.jewelryState); });
              }
            }
          } catch(e) {}
        }
      } else {
        updateConfigurator();
      }
    }

    var seriesId = window.INITIAL_PRODUCT_DATA && window.INITIAL_PRODUCT_DATA.series_id;
    if (seriesId && !window.SERIES_SKU_MAP) {
      fetch('/shopify_section/series_sku_map.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ series_id: seriesId })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.products && data.products.length) {
          window.SERIES_SKU_MAP = data.products;
          if (data.jewelry_states && data.jewelry_states.length && (!window.SERIES_JEWELRY_STATES || !window.SERIES_JEWELRY_STATES.length)) {
            window.SERIES_JEWELRY_STATES = data.jewelry_states;
            if (!window.JEWELRY_STATE) {
              window.JEWELRY_STATE = data.jewelry_states[0];
            }
          }
        }
        boot();
      })
      .catch(function() { boot(); });
    } else {
      boot();
    }

    updateThumbNavButtons();
  });

})();